import { lazy } from "react";

const PayrollChartForm = lazy(() => import("../pages/GeneralPages/PayrollChart/From"));
const LegalChartForm = lazy(() => import("../pages/Executive/LegalChart/Form"));
const SecurityChartForm = lazy(() => import("../pages/Executive/SecurityChart/Form"));
const CorporateChartForm = lazy(() => import("../pages/GeneralPages/CorporateChart/Form"));
const CorporateStaffForm = lazy(() => import("../pages/GeneralPages/CorporateStaff/Form"));
const NRMChartForm = lazy(() => import("../pages/MLM/NRMChart/Form"));
const SaleSupportChartForm = lazy(() => import("../pages/MLM/SaleSupportChart/Form"));
const HrAdminChartForm = lazy(() => import("../pages/HRINF/HrAdminChart/Form"));
const AdministrativeAffairsChartForm = lazy(
  () => import("../pages/HRINF/AdministrativeAffairsChart/Form"),
);
const BuAndOfficeAdminChartForm = lazy(() => import("../pages/BINFPages/BuAndOfficeAdminChart/Form"));
const ProductManagementChartForm = lazy(() => import("../pages/MLM/ProductManagmentChart/From"));

const BudgetingChartForm = lazy(() => import("../pages/Financial/BudgettingChart/Form"));
const FinancialInfoChartForm = lazy(() => import("../pages/Financial/FinancialInfoChart/Form"));
const ProcurementChartForm = lazy(() => import("../pages/Financial/ProcurementChart/Form"));
const AccountClassForm = lazy(() => import("../pages/Financial/AccountClass/Form"));
const GeneralLedgerAccountForm = lazy(() => import("../pages/Financial/GeneralLedgerAccount/Form"));
const SubsidiaryAccountForm = lazy(() => import("../pages/Financial/SubsidiaryAccount/Form"));
const PurchaseProformaForm = lazy(() => import("../pages/Financial/PurchaseProforma/Form"));
const PurchaseInvoiceForm = lazy(() => import("../pages/Financial/PurchaseInvoice/Form"));

const GeographicalDivisionForm = lazy(() => import("../pages/MLM/GeographicalDivision/Form"));
const SellerSupportChartForm = lazy(() => import("../pages/MLM/SellerSupportChart/Form"));
const SellerFrom = lazy(() => import("../pages/MLM/Seller/From"));
const IsMarketerForm = lazy(() => import("../pages/MLM/IsMarketer/IsMarketerForm"));
const CategoryManagementChartForm = lazy(() => import("../pages/MLM/CategoryManagementChart/Form"));
const DefectiveProductStatementForm = lazy(() => import("../pages/MLM/DefectiveProductStatement/Form"));
const ContractTerminationRequestForm = lazy(
  () => import("../pages/MLM/ContractTerminationRequest/Form"),
);

const PointOfSaleForm = lazy(() => import("../pages/MLM/PointOfSale/Form"));
const BeautyAdvisorChartForm = lazy(() => import("../pages/MLM/BeautyAdvisorChart/Form"));
const UserInformationForm = lazy(() => import("../pages/MLM/UserInformation/Form"));
const SaleRepresentativeForm = lazy(() => import("../pages/MLM/SaleRepresentative/Form"));
const RoyalZhickNetworkmarketerForm = lazy(() => import("../pages/MLM/RoyalZhickNetworkmarketer/Form"));
const DeliveryTariffForm = lazy(() => import("../pages/MLM/DeliveryTariff/Form"));
const FreightBoxForm = lazy(() => import("../pages/MLM/FreightBox/Form"));
const InspectionRequestOfDefectiveProductReturnForm = lazy(
  () => import("../pages/MLM/InspectionRequestOfDefectiveProductReturn/Form"),
);
const SkuSellerForm = lazy(() => import("../pages/MLM/SkuSeller/Form"));
const SaleOrderReportForm = lazy(() => import("../pages/OSPPages/SaleOrder/Form"));
const AccountingDocumentForm = lazy(() => import("../pages/Financial/AccountingDocument/Form"));
const PurchaseReturnProformaWithoutUidForm = lazy(
  () => import("../pages/Financial/PurchaseReturnProformaWithoutUid/Form"),
);
const PDDForm = lazy(() => import("../pages/HRINF/PersonnelDocumentDigitization/PDDForm"));
const OrganizationalTitleSalaryDifferenceForm = lazy(
  () => import("../pages/HRINF/OrganizationalTitleSalaryDifference/Form"),
);
const NationalCodeCellphoneOfPersonnelForm = lazy(
  () => import("../pages/HRINF/NationalCodeCellphoneOfPersonnel/Form"),
);
// const PersonnelInformation = lazy(() =>
//   import("../pages/HRINF/ApplicantInformation/PersonnelInformation")
// );
const PersonnelInformation = lazy(
  () => import("../pages/HRINF/ApplicantInformation/MainPage/PersonnelInformation"),
);
const ViewGeneralUserDetails = lazy(() => import("../pages/GeneralPages/GeneralUser/ViewDetails"));
const AdminMarketVisitForm = lazy(() => import("../pages/MarketVisitPages/AdminMarketVisit/Form"));
const SupervisorMarketVisitForm = lazy(
  () => import("../pages/MarketVisitPages/SupervisorMarketVisit/Form"),
);

const ChiefManagementStaffForm = lazy(
  () => import("../pages/OSPPages/ChiefManagementStaff/ChiefManagementStaffForm"),
);
const ChiefManagementChartForm = lazy(
  () => import("../pages/OSPPages/ChiefManagementChart/ChiefManagementChartForm"),
);
const RegulatoryStaffForm = lazy(() => import("../pages/PAVPages/RegulatoryStaff/Form"));
const RegulatoryChartForm = lazy(() => import("../pages/PAVPages/RegulatoryChart/Form"));
const LogisticStaffForm = lazy(() => import("../pages/OSPPages/LogisticStaff/LogisticStaffForm"));
const LogisticChartForm = lazy(() => import("../pages/MLM/LogisticChart/Form"));
const SaleStaffForm = lazy(() => import("../pages/OSPPages/SalePersonStaff/Form"));
const SaleChartForm = lazy(() => import("../pages/OSPPages/SalePersonChart/Form"));
const AccountPartyForm = lazy(() => import("../pages/OSPPages/AccountParty/AccountPartyForm"));
const BrandForm = lazy(() => import("../pages/OSPPages/Brand/BrandForm"));
const CargoForm = lazy(() => import("../pages/OSPPages/Cargo/Form"));
const CustomerCandidateForm = lazy(
  () => import("../pages/OSPPages/CustomerCandidate/CustomerCandidateForm"),
);
const DiscountForm = lazy(() => import("../pages/OSPPages/Discount/DiscountForm"));

const PriceForm = lazy(() => import("../pages/OSPPages/Price/PriceForm"));
const ProductGroupForm = lazy(() => import("../pages/OSPPages/ProductGroup/ProductGroupForm"));
const ResponseForm = lazy(() => import("../pages/OSPPages/Response/ResponseForm"));
const SalePackForm = lazy(() => import("../pages/OSPPages/SalePack/SalePackForm"));
const SellingProductForm = lazy(() => import("../pages/OSPPages/SellingProduct/SellingProductForm"));
const SkuForm = lazy(() => import("../pages/MLM/SKU/Form"));
const PkuForm = lazy(() => import("../pages/MLM/PKU/Form"));
const WarehouseGroupForm = lazy(() => import("../pages/MLM/WarehouseGroup/Form"));
const ComplaintCaseForm = lazy(() => import("../pages/MLM/ComplaintCase/Form"));
const UIDPForm = lazy(() => import("../pages/OSPPages/UIDP/UIDPForm"));
const UserForm = lazy(() => import("../pages/OSPPages/User/UserForm"));
const WarehouseForm = lazy(() => import("../pages/OSPPages/Warehouse/WarehouseForm"));
const WarehouseNoteForm = lazy(() => import("../pages/OSPPages/WarehouseNote/Form"));
const GenerateConsolidated = lazy(() => import("../pages/OSPPages/WarehouseNote/GenerateConsolidate"));
const SelectWarehouseNotesForm = lazy(() => import("../pages/OSPPages/SelectWarehouseNotes/Form"));
const WarehouseOperationForm = lazy(
  () => import("../pages/OSPPages/WarehouseOperation/WarehouseOperationForm"),
);
const ChartDmacDbacForm = lazy(
  () => import("../pages/GeneralPages/ChartDmacDbacForm/ChartDmacDbacForm"),
);
const NonUserDmacDbacForm = lazy(
  () => import("../pages/GeneralPages/NonUserDmacDbacForm/NonUserDmacDbacForm"),
);
const OrganizationalTitleDmacDbacForm = lazy(
  () => import("../pages/GeneralPages/OrganizationalTitleDmacDbacForm/OrganizationalTitleDmacDbacForm"),
);
const UserDmacDbacForm = lazy(() => import("../pages/GeneralPages/UserDmacDbacForm/UserDmacDbacForm"));
const NewOrganizationalTitleForm = lazy(() => import("../pages/GeneralPages/OrganizationalTitle/Form"));
const OrganizationalTitleSpecificationForm = lazy(
  () => import("../pages/HCM/OrganizationalTitleSpecification/Form"),
);
const OrganizationalTitleGroupForm = lazy(
  () => import("../pages/GeneralPages/OrganizationalTitleGroup/Form"),
);
const OrganizationalLevelForm = lazy(() => import("../pages/GeneralPages/OrganizationalLevel/Form"));
const EntityForm = lazy(() => import("../pages/GeneralPages/Entity/Form"));
const FieldForm = lazy(() => import("../pages/GeneralPages/Field/Form"));
const GeneralDacProtocolForm = lazy(() => import("../pages/GeneralPages/GeneralDacProtocol/Form"));
const ProcessVersionForm = lazy(() => import("../pages/GeneralPages/ProcessVersion/Form"));
const ProcessFlowForm = lazy(() => import("../pages/GeneralPages/ProcessFlow/Form"));
const AccountForm = lazy(() => import("../pages/PACPages/Account/Form"));
const AccountInputForm = lazy(() => import("../pages/PACPages/AccountInput/Form"));
const PosForm = lazy(() => import("../pages/PACPages/Pos/Form"));
const PosInputForm = lazy(() => import("../pages/PACPages/PosInput/Form"));
const BranchForm = lazy(() => import("../pages/PACPages/Branch/Form"));
const PosAllocationForm = lazy(() => import("../pages/PACPages/PosAllocation/Form"));
const CollectionPipelineForm = lazy(() => import("../pages/PACPages/CollectionPipeline/Form"));
const LicenseInfoForm = lazy(() => import("../pages/PAVPages/LicenseInfo/Form"));
const CollectorChartForm = lazy(() => import("../pages/PACPages/CollectorChart/Form"));
const TreasurerChartForm = lazy(() => import("../pages/PACPages/TreasurerChart/Form"));
const CollectorStaffForm = lazy(() => import("../pages/PACPages/CollectorStaff/Form"));
const StaffDefinerOfSaleDepartmentChartForm = lazy(
  () => import("../pages/GeneralPages/StaffDefinerOfSaleDepartmentChart/Form"),
);
const StaffDefinerOfSaleDepartmentStaffForm = lazy(
  () => import("../pages/GeneralPages/StaffDefinerOfSaleDepartmentStaff/Form"),
);
const StaffDefinerOfLogisticDepartmentChartForm = lazy(
  () => import("../pages/GeneralPages/StaffDefinerOfLogisticDepartmentChart/Form"),
);
const StaffDefinerOfLogisticDepartmentStaffForm = lazy(
  () => import("../pages/GeneralPages/StaffDefinerOfLogisticDepartmentStaff/Form"),
);
const StaffDefinerOfFinancialDepartmentChartForm = lazy(
  () => import("../pages/GeneralPages/StaffDefinerOfFinancialDepartmentChart/Form"),
);
const StaffDefinerOfFinancialDepartmentStaffForm = lazy(
  () => import("../pages/GeneralPages/StaffDefinerOfFinancialDepartmentStaff/Form"),
);
const TreasurerStaffForm = lazy(() => import("../pages/PACPages/TreasurerStaff/Form"));
const SoftwareAdminChartForm = lazy(() => import("../pages/GeneralPages/SoftwareAdminChart/Form"));
const ChartAndAuxiliaryAdminChartForm = lazy(
  () => import("../pages/GeneralPages/ChartAndAuxiliaryAdminChart/Form"),
);
const ProcessAdminChartForm = lazy(() => import("../pages/GeneralPages/ProcessAdminChart/Form"));
const SuperAdminChartForm = lazy(() => import("../pages/GeneralPages/SuperAdminChart/Form"));
const GeneralUserForm = lazy(() => import("../pages/GeneralPages/GeneralUser/Form"));
const GeneralUserV2Form = lazy(() => import("../pages/GeneralPages/GeneralUserV2/Form"));
const EnumDefinitionForm = lazy(() => import("../pages/GeneralPages/EnumDefinition/Form"));
const UserGroupForm = lazy(() => import("../pages/GeneralPages/UserGroup/Form"));
const TaskForm = lazy(() => import("../pages/GeneralPages/Task/Form"));
const ChartAndAuxiliaryAdminStaffForm = lazy(
  () => import("../pages/GeneralPages/ChartAndAuxiliaryAdminStaff/Form"),
);
const ProcessAdminStaffForm = lazy(() => import("../pages/GeneralPages/ProcessAdminStaff/Form"));
const SoftwareAdminStaffForm = lazy(() => import("../pages/GeneralPages/SoftwareAdminStaff/Form"));
const SuperAdminStaffForm = lazy(() => import("../pages/GeneralPages/SuperAdminStaff/Form"));
const AccessGrantsForm = lazy(() => import("../pages/GeneralPages/EntityConfig/Form"));
const FieldAccessGrantForm = lazy(() => import("../pages/GeneralPages/FieldConfig/Form"));
const FieldConfigForm = lazy(() => import("../pages/GeneralPages/FieldConfigV1/Form"));
const BusinessUnitForm = lazy(() => import("../pages/BINFPages/BusinessUnit/Form"));
const PersonForm = lazy(() => import("../pages/BINFPages/Person/Form"));
// const OfficeForm = lazy(() => import("../pages/BINFPages/Office/Form"));
const OfficeForm = lazy(() => import("../pages/BINFPages/OfficeV1/Form"));
const CustomerReceivableResolutionForm = lazy(
  () => import("../pages/MLM/CustomerReceivableResolution/Form"),
);
const BeautyAdvisorSupervisorReportForm = lazy(
  () => import("../pages/MLM/BeautyAdvisorSupervisorReport/Form"),
);
const BeautyAdvisorSupervisionChartForm = lazy(
  () => import("../pages/MLM/BeautyAdvisorSupervisionChart/Form"),
);
const MedicalAffairsChartForm = lazy(() => import("../pages/MedRep/MedicalAffairsChart/Form"));
const MedRepChartForm = lazy(() => import("../pages/MedRep/MedRepChart/Form"));
const MedRepGeoDivisionSectorForm = lazy(() => import("../pages/MedRep/MedRepGeoDivisionSector/Form"));
const SrmStockManagementChartForm = lazy(() => import("../pages/MedRep/SrmStockManagementChart/Form"));
const StockableObjectManagementChartForm = lazy(
  () => import("../pages/MedRep/StockableObjectManagementChart/Form"),
);
const SrmHrChartForm = lazy(() => import("../pages/MLM/SrmHrChart/Form"));
const SrmSoftwareSupportChartForm = lazy(() => import("../pages/MLM/SrmSoftwareSupportChart/Form"));
const BeautyAdvisorSupervisionSectorForm = lazy(
  () => import("../pages/MLM/BeautyAdvisorSupervisionSector/Form"),
);
const SaleSupportGeoDivisionSectorForm = lazy(
  () => import("../pages/MLM/SaleSupportGeoDivisionSector/Form"),
);

// ================hcm
const JobPositionForm = lazy(() => import("../pages/HCM/JobPosition/Form"));
const HrSegmentForm = lazy(() => import("../pages/HCM/HrSegment/Form"));
const CandidateScreeningForm = lazy(() => import("../pages/HCM/CandidateScreening/Form"));
const InterviewSchedulingAndReschedulingForm = lazy(
  () => import("../pages/HCM/InterviewSchedulingAndRescheduling/Form"),
);
const CognitiveTestQuestionForm = lazy(() => import("../pages/HCM/CognitiveTestQuestion/Form"));
const CandidateAssessmentForm = lazy(() => import("../pages/HCM/CandidateAssessment/Form"));
const CandidateSelectionForm = lazy(() => import("../pages/HCM/CandidateSelectionV1/Form"));
const HiringForm = lazy(() => import("../pages/HCM/Hiring/Form"));
const DocumentSubmissionSchedulingForm = lazy(
  () => import("../pages/HCM/DocumentSubmissionScheduling/Form"),
);
const JobPositionReport = lazy(() => import("../pages/HCM/JobPositionReportV2/Form"));
const GsmRoutingForm = lazy(() => import("../pages/GSM/GsmRouting/Form"));
const DelegationForm = lazy(() => import("../pages/Delegation/GivenByMe/Form"));
// ======= correspondence
const CorrespondenceInboxForm = lazy(() => import("../pages/Correspondence/MessagesInbox/Form"));
// const CorrespondenceSentForm = lazy(() => import("../pages/Correspondence/Sent/Form"));
// const CorrespondenceDraftForm = lazy(() => import("../pages/Correspondence/Draft/Form"));

const dbacDmacGeneralForms = [
  // ========================================================= ***ChartDbacAndDmac Form** =========================================================
  {
    packageName: "general",
    entityNames: ["ChartDmacProtocol", "AdvancedChartDbacProtocol"],
    path: "/chart-dbac-and-dmac/add/:fromList",
    element: <ChartDmacDbacForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityNames: ["ChartDmacProtocol", "AdvancedChartDbacProtocol"],
    path: "/chart-dbac-and-dmac/edit/:fromList/:entityId/:chartId",
    element: <ChartDmacDbacForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityNames: ["ChartDmacProtocol", "AdvancedChartDbacProtocol"],
    path: "/chart-dbac-and-dmac/edit/:fromList/:entityId/:entityName/:chartId/:chartName",
    element: <ChartDmacDbacForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityNames: ["ChartDmacProtocol", "AdvancedChartDbacProtocol"],
    path: "/chart-dbac-and-dmac/edit/:fromList/:entityId/:entityName/:chartId/:chartName/:packageId/:packageName",
    element: <ChartDmacDbacForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityNames: ["ChartDmacProtocol", "AdvancedChartDbacProtocol"],
    path: "/chart-dbac-and-dmac/draft/:id",
    element: <ChartDmacDbacForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***NonUserDbacAndDmac Form** =========================================================
  {
    packageName: "general",
    entityNames: ["NonUserDmacProtocol", "AdvancedNonUserDbacProtocol"],
    path: "/non-user-dbac-and-dmac/add/:fromList",
    element: <NonUserDmacDbacForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityNames: ["NonUserDmacProtocol", "AdvancedNonUserDbacProtocol"],
    path: "/non-user-dbac-and-dmac/edit/:fromList/:entityId/:nonUserTitleId",
    element: <NonUserDmacDbacForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityNames: ["NonUserDmacProtocol", "AdvancedNonUserDbacProtocol"],
    path: "/non-user-dbac-and-dmac/draft/:id",
    element: <NonUserDmacDbacForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***OrganizationalTitleDbacAndDmac Form** =========================================================
  // {
  //   packageName: "general",
  //   entityNames: ["OrganizationalTitleDmacProtocol", "AdvancedOrganizationalTitleDbacProtocol"],
  //   path: "/organizational-title/add/:fromList",
  //   element: <OrganizationalTitleDmacDbacForm observe={false} edit={false} fromDraft={false} />,
  // },
  // {
  //   packageName: "general",
  //   entityNames: ["OrganizationalTitleDmacProtocol", "AdvancedOrganizationalTitleDbacProtocol"],
  //   path: "/organizational-title/edit/:fromList/:entityId/:organizationalTitleId",
  //   element: <OrganizationalTitleDmacDbacForm observe={false} edit={true} fromDraft={false} />,
  // },
  // {
  //   packageName: "general",
  //   entityNames: ["OrganizationalTitleDmacProtocol", "AdvancedOrganizationalTitleDbacProtocol"],
  //   path: "/organizational-title/draft/:id",
  //   element: <OrganizationalTitleDmacDbacForm observe={false} edit={false} fromDraft={true} />,
  // },
  {
    packageName: "general",
    entityNames: ["OrganizationalTitleDmacProtocol", "AdvancedOrganizationalTitleDbacProtocol"],
    path: "/organizational-title-dbac-and-dmac/add/:fromList",
    element: <OrganizationalTitleDmacDbacForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityNames: ["OrganizationalTitleDmacProtocol", "AdvancedOrganizationalTitleDbacProtocol"],
    path: "/organizational-title-dbac-and-dmac/edit/:fromList/:entityId/:organizationalTitleId",
    element: <OrganizationalTitleDmacDbacForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityNames: ["OrganizationalTitleDmacProtocol", "AdvancedOrganizationalTitleDbacProtocol"],
    path: "/organizational-title-dbac-and-dmac/edit/:fromList/:entityId/:entityName/:organizationalTitleId/:organizationalTitleName",
    element: <OrganizationalTitleDmacDbacForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityNames: ["OrganizationalTitleDmacProtocol", "AdvancedOrganizationalTitleDbacProtocol"],
    path: "/organizational-title-dbac-and-dmac/edit/:fromList/:entityId/:entityName/:organizationalTitleId/:organizationalTitleName/:packageId/:packageName",
    element: <OrganizationalTitleDmacDbacForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityNames: ["OrganizationalTitleDmacProtocol", "AdvancedOrganizationalTitleDbacProtocol"],
    path: "/organizational-title-dbac-and-dmac/draft/:id",
    element: <OrganizationalTitleDmacDbacForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***UserDbacAndDmac Form** =========================================================
  {
    packageName: "general",
    entityNames: ["UserDmacProtocol", "AdvancedUserDbacProtocol"],
    path: "/user/add/:fromList",
    element: <UserDmacDbacForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityNames: ["UserDmacProtocol", "AdvancedUserDbacProtocol"],
    path: "/user/edit/:fromList/:entityId/:userId",
    element: <UserDmacDbacForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityNames: ["UserDmacProtocol", "AdvancedUserDbacProtocol"],
    path: "/user/draft/:id",
    element: <UserDmacDbacForm observe={false} edit={false} fromDraft={true} />,
  },
];
const ospChartStaffForms = [
  // ========================================================= ***ChiefManagementChart Form** =========================================================
  {
    packageName: "onlineShopPortal",
    entityName: "ChiefManagementChart",
    path: "/chief-management-chart/add",
    element: <ChiefManagementChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "ChiefManagementChart",
    path: "/chief-management-chart/edit/:id",
    element: <ChiefManagementChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "ChiefManagementChart",
    path: "/chief-management-chart/draft/:id",
    element: <ChiefManagementChartForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***ChiefManagementStaff Form** =========================================================
  {
    packageName: "onlineShopPortal",
    entityName: "ChiefManagementStaff",
    path: "/chief-management-staff/add",
    element: <ChiefManagementStaffForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "ChiefManagementStaff",
    path: "/chief-management-staff/edit/:id",
    element: <ChiefManagementStaffForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "ChiefManagementStaff",
    path: "/chief-management-staff/draft/:id",
    element: <ChiefManagementStaffForm observe={false} edit={false} fromDraft={true} />,
  },
  // // ========================================================= ***LogisticChart Form** =========================================================
  // {
  //   packageName: "onlineShopPortal",
  //   entityName: "LogisticChart",
  //   path: "/logistic-chart/add",
  //   element: <LogisticChartForm observe={false} edit={false} fromDraft={false} />,
  // },
  // {
  //   packageName: "onlineShopPortal",
  //   entityName: "LogisticChart",
  //   path: "/logistic-chart/edit/:id",
  //   element: <LogisticChartForm observe={false} edit={true} fromDraft={false} />,
  // },
  // {
  //   packageName: "onlineShopPortal",
  //   entityName: "LogisticChart",
  //   path: "/logistic-chart/draft/:id",
  //   element: <LogisticChartForm observe={false} edit={false} fromDraft={true} />,
  // },
  // ========================================================= ***LogisticStaff Form** =========================================================
  {
    packageName: "onlineShopPortal",
    entityName: "LogisticStaff",
    path: "/logistic-staff/add",
    element: <LogisticStaffForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "LogisticStaff",
    path: "/logistic-staff/edit/:id",
    element: <LogisticStaffForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "LogisticStaff",
    path: "/logistic-staff/draft/:id",
    element: <LogisticStaffForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***SaleChart Form** =========================================================
  {
    packageName: "onlineShopPortal",
    entityName: "SalePersonChart",
    path: "/sale-person-chart/add",
    element: <SaleChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "SalePersonChart",
    path: "/sale-person-chart/edit/:id",
    element: <SaleChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "SalePersonChart",
    path: "/sale-person-chart/draft/:id",
    element: <SaleChartForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***SaleStaff Form** =========================================================
  {
    packageName: "onlineShopPortal",
    entityName: "SalePersonStaff",
    path: "/sale-person-staff/add",
    element: <SaleStaffForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "SalePersonStaff",
    path: "/sale-person-staff/edit/:id",
    element: <SaleStaffForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "SalePersonStaff",
    path: "/sale-person-staff/draft/:id",
    element: <SaleStaffForm observe={false} edit={false} fromDraft={true} />,
  },
];
const generalForms = [
  // ========================================================= *** CORE Task** =========================================================
  {
    packageName: "general",
    entityName: "Task",
    path: "/task/add",
    element: <TaskForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "Task",
    path: "/task/edit/:id",
    element: <TaskForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "Task",
    path: "/task/draft/:id",
    element: <TaskForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= *** CORE GeneralUser** =========================================================
  {
    packageName: "general",
    entityName: "User",
    path: "/general/user/add",
    element: <GeneralUserForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "User",
    path: "/general/user/view/:id",
    element: <ViewGeneralUserDetails observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "User",
    path: "/general/user/edit/:id",
    element: <GeneralUserForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "User",
    path: "/general/user/draft/:id",
    element: <GeneralUserForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= *** CORE GeneralUserV2** =========================================================
  {
    packageName: "general",
    entityName: "User",
    path: "/general/userV2/add",
    element: <GeneralUserV2Form observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "User",
    path: "/general/userV2/edit/:id",
    element: <GeneralUserV2Form observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "User",
    path: "/general/userV2/draft/:id",
    element: <GeneralUserV2Form observe={false} edit={false} fromDraft={true} />,
  },
  {
    packageName: "general",
    entityName: "User",
    path: "/general/userV2/view/:id",
    element: <GeneralUserV2Form observe={true} edit={false} fromDraft={false} />,
  },
  // ========================================================= *** CORE EnumDefinition** =========================================================
  {
    packageName: "general",
    entityName: "EnumDefinition",
    path: "/general/enum-definition/add",
    element: <EnumDefinitionForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "EnumDefinition",
    path: "/general/enum-definition/edit/:id",
    element: <EnumDefinitionForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "EnumDefinition",
    path: "/general/enum-definition/draft/:id",
    element: <EnumDefinitionForm observe={false} edit={false} fromDraft={true} />,
  },
  {
    packageName: "general",
    entityName: "EnumDefinition",
    path: "/general/enum-definition/view/:id",
    element: <EnumDefinitionForm observe={true} edit={false} fromDraft={false} />,
  },
  // ========================================================= *** CORE UserGroup** =========================================================
  {
    packageName: "general",
    entityName: "UserGroup",
    path: "/general/user-group/add",
    element: <UserGroupForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "UserGroup",
    path: "/general/user-group/edit/:id",
    element: <UserGroupForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "UserGroup",
    path: "/general/user-group/draft/:id",
    element: <UserGroupForm observe={false} edit={false} fromDraft={true} />,
  },
  {
    packageName: "general",
    entityName: "UserGroup",
    path: "/general/user-group/view/:id",
    element: <UserGroupForm observe={true} edit={false} fromDraft={false} />,
  },
  // ========================================================= *** CORE GeneralDacProtocol *** =========================================================
  {
    packageName: "general",
    entityName: "GeneralDacProtocol",
    path: "/general-dac-protocol/add/:fromRoute",
    element: <GeneralDacProtocolForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "GeneralDacProtocol",
    path: "/general-dac-protocol/edit/:fromRoute/:id",
    element: <GeneralDacProtocolForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "GeneralDacProtocol",
    path: "/general-dac-protocol/edit/:fromRoute/:entityId/:entityName/:packageId/:packageName",
    element: <GeneralDacProtocolForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "GeneralDacProtocol",
    path: "/general-dac-protocol/draft/:id",
    element: <GeneralDacProtocolForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= *** CORE PROCESSFLOW** =========================================================
  {
    packageName: "general",
    entityName: "ProcessFlow",
    path: "/process-flow/add",
    element: <ProcessFlowForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "ProcessFlow",
    path: "/process-flow/edit/:entityIdParam/:entityNameParam",
    element: <ProcessFlowForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "ProcessFlow",
    path: "/process-flow/edit/:entityIdParam/:entityNameParam/:processVersionIdParam/:processVersionVersionParam",
    element: <ProcessFlowForm observe={false} edit={false} fromDraft={false} />,
  },
  // ========================================================= *** CORE PROCESSVERSION** =========================================================
  {
    packageName: "general",
    entityName: "ProcessVersion",
    path: "/process-version/add/:fromRoute",
    element: <ProcessVersionForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "ProcessVersion",
    path: "/process-version/edit/:fromRoute/:id",
    element: <ProcessVersionForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "ProcessVersion",
    path: "/process-version/draft/:fromRoute/:id",
    element: <ProcessVersionForm observe={false} edit={false} fromDraft={true} />,
  },
  {
    packageName: "general",
    entityName: "ProcessVersion",
    path: "/process-version/add/:fromRoute/:entityId/:entityName",
    element: <ProcessVersionForm observe={false} edit={false} fromDraft={false} />,
  },
];
const coreAccessForms = [
  // ========================================================= ***EntityConfig Form** =========================================================
  {
    packageName: "baseKit",
    entityName: "EntityConfig",
    path: "/general/entity-config/add",
    element: <AccessGrantsForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "baseKit",
    entityName: "EntityConfig",
    path: "/general/entity-config/edit/:id",
    element: <AccessGrantsForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "baseKit",
    entityName: "EntityConfig",
    path: "/general/entity-config/draft/:id",
    element: <AccessGrantsForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***FieldConfig Form** =========================================================
  {
    packageName: "baseKit",
    entityName: "FieldConfig",
    path: "general/field-config/edit",
    element: <FieldConfigForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "baseKit",
    entityName: "FieldConfig",
    path: "general/field-config/old-version/add",
    element: <FieldAccessGrantForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "baseKit",
    entityName: "FieldConfig",
    path: "general/field-config/edit/:id",
    element: <FieldAccessGrantForm observe={false} edit={true} fromDraft={false} />,
  },
  // {
  //   packageName: "baseKit",
  //   entityName: "FieldConfig",
  //   path: "general/field-config/draft/:id",
  //   element: <FieldAccessGrantForm observe={false} edit={false} fromDraft={true} />,
  // },
  // ========================================================= ***FieldConfig Form V1** =========================================================
  // {
  //   packageName: "baseKit",
  //   entityName: "FieldConfig",
  //   path: "general/field-config/add",
  //   element: <FieldConfigForm observe={false} edit={false} fromDraft={false} />,
  // },
];
const pacForms = [
  // ========================================================= ***Account Form** =========================================================
  {
    packageName: "posAccountControl",
    entityName: "BankAccount",
    path: "/posAccountControl/bank-account/add",
    element: <AccountForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "posAccountControl",
    entityName: "BankAccount",
    path: "/posAccountControl/bank-account/edit/:id",
    element: <AccountForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "posAccountControl",
    entityName: "BankAccount",
    path: "/posAccountControl/bank-account/draft/:id",
    element: <AccountForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***BankAccountInput Form** =========================================================
  {
    packageName: "posAccountControl",
    entityName: "BankAccountInput",
    path: "/posAccountControl/bank-input/add",
    element: <AccountInputForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "posAccountControl",
    entityName: "BankAccountInput",
    path: "/posAccountControl/bank-input/edit/:id",
    element: <AccountInputForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "posAccountControl",
    entityName: "BankAccountInput",
    path: "/posAccountControl/bank-input/draft/:id",
    element: <AccountInputForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***Pos Form** =========================================================
  {
    packageName: "posAccountControl",
    entityName: "PosDevice",
    path: "/posAccountControl/-device/add",
    element: <PosForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "posAccountControl",
    entityName: "PosDevice",
    path: "/posAccountControl/pos-device/edit/:id",
    element: <PosForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "posAccountControl",
    entityName: "PosDevice",
    path: "/posAccountControl/pos-device/draft/:id",
    element: <PosForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***PosInput Form** =========================================================
  {
    packageName: "posAccountControl",
    entityName: "PosInput",
    path: "/posAccountControl/pos-input/add",
    element: <PosInputForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "posAccountControl",
    entityName: "PosInput",
    path: "/posAccountControl/pos-input/edit/:id",
    element: <PosInputForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "posAccountControl",
    entityName: "PosInput",
    path: "/posAccountControl/pos-input/draft/:id",
    element: <PosInputForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***Branch Form** =========================================================
  {
    packageName: "posAccountControl",
    entityName: "Branch",
    path: "/posAccountControl/branch/add",
    element: <BranchForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "posAccountControl",
    entityName: "Branch",
    path: "/posAccountControl/branch/edit/:id",
    element: <BranchForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "posAccountControl",
    entityName: "Branch",
    path: "/posAccountControl/branch/draft/:id",
    element: <BranchForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***PosAllocation Form** =========================================================
  {
    packageName: "posAccountControl",
    entityName: "PosAllocation",
    path: "/posAccountControl/pos-allocation/add",
    element: <PosAllocationForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "posAccountControl",
    entityName: "PosAllocation",
    path: "/posAccountControl/pos-allocation/edit/:id",
    element: <PosAllocationForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "posAccountControl",
    entityName: "PosAllocation",
    path: "/posAccountControl/pos-allocation/draft/:id",
    element: <PosAllocationForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***CollectionPipeline Form** =========================================================
  {
    packageName: "posAccountControl",
    entityName: "CollectionPipeline",
    path: "/posAccountControl/collection-pipeline/add",
    element: <CollectionPipelineForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "posAccountControl",
    entityName: "CollectionPipeline",
    path: "/posAccountControl/collection-pipeline/edit/:id",
    element: <CollectionPipelineForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "posAccountControl",
    entityName: "CollectionPipeline",
    path: "/posAccountControl/collection-pipeline/draft/:id",
    element: <CollectionPipelineForm observe={false} edit={false} fromDraft={true} />,
  },
];
const pavForms = [
  // ========================================================= ***LicenseInfo Form** =========================================================
  {
    packageName: "productAuthenticityVerification",
    entityName: "LicenseInfo",
    path: "/productAuthenticityVerification/license-info/add",
    element: <LicenseInfoForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "productAuthenticityVerification",
    entityName: "LicenseInfo",
    path: "/productAuthenticityVerification/license-info/edit/:id",
    element: <LicenseInfoForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "productAuthenticityVerification",
    entityName: "LicenseInfo",
    path: "/productAuthenticityVerification/license-info/draft/:id",
    element: <LicenseInfoForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***RegulatoryChart Form** =========================================================
  {
    packageName: "productAuthenticityVerification",
    entityName: "RegulatoryChart",
    path: "/productAuthenticityVerification/regulatory-chart/add",
    element: <RegulatoryChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "productAuthenticityVerification",
    entityName: "RegulatoryChart",
    path: "/productAuthenticityVerification/regulatory-chart/edit/:id",
    element: <RegulatoryChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "productAuthenticityVerification",
    entityName: "RegulatoryChart",
    path: "/productAuthenticityVerification/regulatory-chart/draft/:id",
    element: <RegulatoryChartForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***RegulatoryStaff Form** =========================================================
  {
    packageName: "productAuthenticityVerification",
    entityName: "RegulatoryStaff",
    path: "/productAuthenticityVerification/regulatory-staff/add",
    element: <RegulatoryStaffForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "productAuthenticityVerification",
    entityName: "RegulatoryStaff",
    path: "/productAuthenticityVerification/regulatory-staff/edit/:id",
    element: <RegulatoryStaffForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "productAuthenticityVerification",
    entityName: "RegulatoryStaff",
    path: "/productAuthenticityVerification/regulatory-staff/draft/:id",
    element: <RegulatoryStaffForm observe={false} edit={false} fromDraft={true} />,
  },
];
const pacChartStaffForms = [
  // ========================================================= ***TreasurerChart Form** =========================================================
  {
    packageName: "posAccountControl",
    entityName: "TreasurerChart",
    path: "/posAccountControl/treasurer-chart/add",
    element: <TreasurerChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "posAccountControl",
    entityName: "TreasurerChart",
    path: "/posAccountControl/treasurer-chart/edit/:id",
    element: <TreasurerChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "posAccountControl",
    entityName: "TreasurerChart",
    path: "/posAccountControl/treasurer-chart/draft/:id",
    element: <TreasurerChartForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***CollectorChart Form** =========================================================
  {
    packageName: "posAccountControl",
    entityName: "CollectorChart",
    path: "/posAccountControl/collector-chart/add",
    element: <CollectorChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "posAccountControl",
    entityName: "CollectorChart",
    path: "/posAccountControl/collector-chart/edit/:id",
    element: <CollectorChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "posAccountControl",
    entityName: "CollectorChart",
    path: "/posAccountControl/collector-chart/draft/:id",
    element: <CollectorChartForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***CollectorStaff Form** =========================================================
  {
    packageName: "posAccountControl",
    entityName: "CollectorStaff",
    path: "/posAccountControl/collector-staff/add",
    element: <CollectorStaffForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "posAccountControl",
    entityName: "CollectorStaff",
    path: "/posAccountControl/collector-staff/edit/:id",
    element: <CollectorStaffForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "posAccountControl",
    entityName: "CollectorStaff",
    path: "/posAccountControl/collector-staff/draft/:id",
    element: <CollectorStaffForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***TreasurerStaff Form** =========================================================
  {
    packageName: "posAccountControl",
    entityName: "TreasurerStaff",
    path: "/posAccountControl/treasurer-staff/add",
    element: <TreasurerStaffForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "posAccountControl",
    entityName: "TreasurerStaff",
    path: "/posAccountControl/treasurer-staff/edit/:id",
    element: <TreasurerStaffForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "posAccountControl",
    entityName: "TreasurerStaff",
    path: "/posAccountControl/treasurer-staff/draft/:id",
    element: <TreasurerStaffForm observe={false} edit={false} fromDraft={true} />,
  },
];
const generalChartStaffForms = [
  // ========================================================= ***ChartAndAuxiliaryAdminChart Form** =========================================================
  {
    packageName: "general",
    entityName: "ChartAndAuxiliaryAdminChart",
    path: "/chart-and-auxiliary-admin-chart/add",
    element: <ChartAndAuxiliaryAdminChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "ChartAndAuxiliaryAdminChart",
    path: "/chart-and-auxiliary-admin-chart/edit/:id",
    element: <ChartAndAuxiliaryAdminChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "ChartAndAuxiliaryAdminChart",
    path: "/chart-and-auxiliary-admin-chart/draft/:id",
    element: <ChartAndAuxiliaryAdminChartForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***ProcessAdminChart Form** =========================================================
  {
    packageName: "general",
    entityName: "ProcessAdminChart",
    path: "/process-admin-chart/add",
    element: <ProcessAdminChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "ProcessAdminChart",
    path: "/process-admin-chart/edit/:id",
    element: <ProcessAdminChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "ProcessAdminChart",
    path: "/process-admin-chart/draft/:id",
    element: <ProcessAdminChartForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***SoftwareAdminChart Form** =========================================================
  {
    packageName: "general",
    entityName: "SoftwareAdminChart",
    path: "/software-admin-chart/add",
    element: <SoftwareAdminChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "SoftwareAdminChart",
    path: "/software-admin-chart/edit/:id",
    element: <SoftwareAdminChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "SoftwareAdminChart",
    path: "/software-admin-chart/draft/:id",
    element: <SoftwareAdminChartForm observe={false} edit={false} fromDraft={true} />,
  },

  // ========================================================= ***SuperAdminChart Form** =========================================================
  {
    packageName: "general",
    entityName: "SuperAdminChart",
    path: "/super-admin-chart/add",
    element: <SuperAdminChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "SuperAdminChart",
    path: "/super-admin-chart/edit/:id",
    element: <SuperAdminChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "SuperAdminChart",
    path: "/super-admin-chart/draft/:id",
    element: <SuperAdminChartForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***SuperAdminStaff Form** =========================================================
  {
    packageName: "general",
    entityName: "SuperAdminStaff",
    path: "/super-admin-staff/add",
    element: <SuperAdminStaffForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "SuperAdminStaff",
    path: "/super-admin-staff/edit/:id",
    element: <SuperAdminStaffForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "SuperAdminStaff",
    path: "/super-admin-staff/draft/:id",
    element: <SuperAdminStaffForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***ChartAndAuxiliaryAdminStaff Form** =========================================================
  {
    packageName: "general",
    entityName: "ChartAndAuxiliaryAdminStaff",
    path: "/chart-and-auxiliary-admin-staff/add",
    element: <ChartAndAuxiliaryAdminStaffForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "ChartAndAuxiliaryAdminStaff",
    path: "/chart-and-auxiliary-admin-staff/edit/:id",
    element: <ChartAndAuxiliaryAdminStaffForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "ChartAndAuxiliaryAdminStaff",
    path: "/chart-and-auxiliary-admin-staff/draft/:id",
    element: <ChartAndAuxiliaryAdminStaffForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***ProcessAdminStaff Form** =========================================================
  {
    packageName: "general",
    entityName: "ProcessAdminStaff",
    path: "/process-admin-staff/add",
    element: <ProcessAdminStaffForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "ProcessAdminStaff",
    path: "/process-admin-staff/edit/:id",
    element: <ProcessAdminStaffForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "ProcessAdminStaff",
    path: "/process-admin-staff/draft/:id",
    element: <ProcessAdminStaffForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***SoftwareAdminStaff Form** =========================================================
  {
    packageName: "general",
    entityName: "SoftwareAdminStaff",
    path: "/software-admin-staff/add",
    element: <SoftwareAdminStaffForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "SoftwareAdminStaff",
    path: "/software-admin-staff/edit/:id",
    element: <SoftwareAdminStaffForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "SoftwareAdminStaff",
    path: "/software-admin-staff/draft/:id",
    element: <SoftwareAdminStaffForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***StaffDefinerOfFinancialDepartmentChart Form** =========================================================
  {
    packageName: "general",
    entityName: "StaffDefinerOfFinancialDepartmentChart",
    path: "/staff-definer-of-financial-department-chart/add",
    element: (
      <StaffDefinerOfFinancialDepartmentChartForm observe={false} edit={false} fromDraft={false} />
    ),
  },
  {
    packageName: "general",
    entityName: "StaffDefinerOfFinancialDepartmentChart",
    path: "/staff-definer-of-financial-department-chart/edit/:id",
    element: (
      <StaffDefinerOfFinancialDepartmentChartForm observe={false} edit={true} fromDraft={false} />
    ),
  },
  {
    packageName: "general",
    entityName: "StaffDefinerOfFinancialDepartmentChart",
    path: "/staff-definer-of-financial-department-chart/draft/:id",
    element: (
      <StaffDefinerOfFinancialDepartmentChartForm observe={false} edit={false} fromDraft={true} />
    ),
  },
  // ========================================================= ***StaffDefinerOfFinancialDepartmentStaff Form** =========================================================
  {
    packageName: "general",
    entityName: "StaffDefinerOfFinancialDepartmentStaff",
    path: "/staff-definer-of-financial-department-staff/add",
    element: (
      <StaffDefinerOfFinancialDepartmentStaffForm observe={false} edit={false} fromDraft={false} />
    ),
  },
  {
    packageName: "general",
    entityName: "StaffDefinerOfFinancialDepartmentStaff",
    path: "/staff-definer-of-financial-department-staff/edit/:id",
    element: (
      <StaffDefinerOfFinancialDepartmentStaffForm observe={false} edit={true} fromDraft={false} />
    ),
  },
  {
    packageName: "general",
    entityName: "StaffDefinerOfFinancialDepartmentStaff",
    path: "/staff-definer-of-financial-department-staff/draft/:id",
    element: (
      <StaffDefinerOfFinancialDepartmentStaffForm observe={false} edit={false} fromDraft={true} />
    ),
  },
  // ========================================================= ***StaffDefinerOfLogisticDepartmentChart Form** =========================================================
  {
    packageName: "general",
    entityName: "StaffDefinerOfLogisticDepartmentChart",
    path: "/staff-definer-of-logistic-department-chart/add",
    element: (
      <StaffDefinerOfLogisticDepartmentChartForm observe={false} edit={false} fromDraft={false} />
    ),
  },
  {
    packageName: "general",
    entityName: "StaffDefinerOfLogisticDepartmentChart",
    path: "/staff-definer-of-logistic-department-chart/edit/:id",
    element: <StaffDefinerOfLogisticDepartmentChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "StaffDefinerOfLogisticDepartmentChart",
    path: "/staff-definer-of-logistic-department-chart/draft/:id",
    element: <StaffDefinerOfLogisticDepartmentChartForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***StaffDefinerOfLogisticDepartmentStaff Form** =========================================================
  {
    packageName: "general",
    entityName: "StaffDefinerOfLogisticDepartmentStaff",
    path: "/staff-definer-of-logistic-department-staff/add",
    element: (
      <StaffDefinerOfLogisticDepartmentStaffForm observe={false} edit={false} fromDraft={false} />
    ),
  },
  {
    packageName: "general",
    entityName: "StaffDefinerOfLogisticDepartmentStaff",
    path: "/staff-definer-of-logistic-department-staff/edit/:id",
    element: <StaffDefinerOfLogisticDepartmentStaffForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "StaffDefinerOfLogisticDepartmentStaff",
    path: "/staff-definer-of-logistic-department-staff/draft/:id",
    element: <StaffDefinerOfLogisticDepartmentStaffForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***StaffDefinerOfSaleDepartmentChart Form** =========================================================
  {
    packageName: "general",
    entityName: "StaffDefinerOfSaleDepartmentChart",
    path: "/staff-definer-of-sale-department-chart/add",
    element: <StaffDefinerOfSaleDepartmentChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "StaffDefinerOfSaleDepartmentChart",
    path: "/staff-definer-of-sale-department-chart/edit/:id",
    element: <StaffDefinerOfSaleDepartmentChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "StaffDefinerOfSaleDepartmentChart",
    path: "/staff-definer-of-sale-department-chart/draft/:id",
    element: <StaffDefinerOfSaleDepartmentChartForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***StaffDefinerOfSaleDepartmentStaff Form** =========================================================
  {
    packageName: "general",
    entityName: "StaffDefinerOfSaleDepartmentStaff",
    path: "/staff-definer-of-sale-department-staff/add",
    element: <StaffDefinerOfSaleDepartmentStaffForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "StaffDefinerOfSaleDepartmentStaff",
    path: "/staff-definer-of-sale-department-staff/edit/:id",
    element: <StaffDefinerOfSaleDepartmentStaffForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "general",
    entityName: "StaffDefinerOfSaleDepartmentStaff",
    path: "/staff-definer-of-sale-department-staff/draft/:id",
    element: <StaffDefinerOfSaleDepartmentStaffForm observe={false} edit={false} fromDraft={true} />,
  },
];
const ospAdminForms = [
  // ========================================================= ***AccountParty Form** =========================================================
  {
    packageName: "onlineShopPortal",
    entityName: "AccountParty",
    path: "/account-party/add",
    element: <AccountPartyForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "AccountParty",
    path: "/account-party/edit/:id",
    element: <AccountPartyForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "AccountParty",
    path: "/account-party/draft/:id",
    element: <AccountPartyForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***Brand Form** =========================================================
  {
    packageName: "onlineShopPortal",
    entityName: "Brand",
    path: "/brand/add",
    element: <BrandForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "Brand",
    path: "/brand/edit/:id",
    element: <BrandForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "Brand",
    path: "/brand/draft/:id",
    element: <BrandForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***Cargo Form** =========================================================
  {
    packageName: "onlineShopPortal",
    entityName: "Cargo",
    path: "/cargo/add",
    element: <CargoForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "Cargo",
    path: "/cargo/edit/:id",
    element: <CargoForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "Cargo",
    path: "/cargo/draft/:id",
    element: <CargoForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***CustomerCandidate Form** =========================================================
  {
    packageName: "onlineShopPortal",
    entityName: "CustomerCandidate",
    path: "/customer-candidate/add",
    element: <CustomerCandidateForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "CustomerCandidate",
    path: "/customer-candidate/edit/:id",
    element: <CustomerCandidateForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "CustomerCandidate",
    path: "/customer-candidate/draft/:id",
    element: <CustomerCandidateForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***Response Form** =========================================================
  {
    packageName: "onlineShopPortal",
    entityName: "Replay",
    path: "/response/add",
    element: <ResponseForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "Replay",
    path: "/response/edit/:id",
    element: <ResponseForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "Replay",
    path: "/response/draft/:id",
    element: <ResponseForm observe={false} edit={false} fromDraft={true} />,
  },

  // ========================================================= ***ProductGroup Form** =========================================================
  {
    packageName: "onlineShopPortal",
    entityName: "ProductGroup",
    path: "/product-group/add",
    element: <ProductGroupForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "ProductGroup",
    path: "/product-group/edit/:id",
    element: <ProductGroupForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "ProductGroup",
    path: "/product-group/draft/:id",
    element: <ProductGroupForm observe={false} edit={false} fromDraft={true} />,
  },

  // ========================================================= ***Discount Form** =========================================================
  {
    packageName: "onlineShopPortal",
    entityName: "Discount",
    path: "/discount/add",
    element: <DiscountForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "Discount",
    path: "/discount/edit/:id",
    element: <DiscountForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "Discount",
    path: "/discount/draft/:id",
    element: <DiscountForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***SalePack Form** =========================================================
  {
    packageName: "onlineShopPortal",
    entityName: "SalePack",
    path: "/sale-pack/add",
    element: <SalePackForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "SalePack",
    path: "/sale-pack/edit/:id",
    element: <SalePackForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "SalePack",
    path: "/sale-pack/draft/:id",
    element: <SalePackForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***SellingProduct Form** =========================================================
  {
    packageName: "onlineShopPortal",
    entityName: "SellingProduct",
    path: "/selling-product/add",
    element: <SellingProductForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "SellingProduct",
    path: "/selling-product/edit/:id",
    element: <SellingProductForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "SellingProduct",
    path: "/selling-product/draft/:id",
    element: <SellingProductForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***UIDP Form** =========================================================
  {
    packageName: "onlineShopPortal",
    entityName: "UIDP",
    path: "/uidp/add",
    element: <UIDPForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "UIDP",
    path: "/uidp/edit/:id",
    element: <UIDPForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "UIDP",
    path: "/uidp/draft/:id",
    element: <UIDPForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***WarehouseOperation Form** =========================================================
  {
    packageName: "onlineShopPortal",
    entityName: "WarehouseOperation",
    path: "/warehouse-operation/add",
    element: <WarehouseOperationForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "WarehouseOperation",
    path: "/warehouse-operation/edit/:id",
    element: <WarehouseOperationForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "WarehouseOperation",
    path: "/warehouse-operation/draft/:id",
    element: <WarehouseOperationForm observe={false} edit={false} fromDraft={true} />,
  },

  // ========================================================= ***User Form** =========================================================
  {
    packageName: "onlineShopPortal",
    entityName: "User",
    path: "/user/add",
    element: <UserForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "User",
    path: "/user/edit/:id",
    element: <UserForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "User",
    path: "/user/draft/:id",
    element: <UserForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***Warehouse Form** =========================================================
  {
    packageName: "onlineShopPortal",
    entityName: "Warehouse",
    path: "/warehouse/add",
    element: <WarehouseForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "Warehouse",
    path: "/warehouse/edit/:id",
    element: <WarehouseForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "Warehouse",
    path: "/warehouse/draft/:id",
    element: <WarehouseForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***WarehouseNote Form** =========================================================
  {
    packageName: "onlineShopPortal",
    entityName: "WarehouseNote",
    path: "/warehouse-note/add",
    element: <WarehouseNoteForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "WarehouseNote",
    path: "/warehouse-note/edit/:id",
    element: <WarehouseNoteForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "WarehouseNote",
    path: "/warehouse-note/draft/:id",
    element: <WarehouseNoteForm observe={false} edit={false} fromDraft={true} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "WarehouseNote",
    path: "/warehouse-note/view/:id",
    element: <WarehouseNoteForm observe={true} edit={false} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "WarehouseNote",
    path: "/warehouse-note/viewGenerateConsolidated",
    element: <GenerateConsolidated observe={true} edit={false} fromDraft={false} />,
  },
  // ========================================================= ***SaleOrder Form** =========================================================
  {
    packageName: "onlineShopPortal",
    entityName: "SaleOrder",
    path: "/sale-order/add",
    element: <SaleOrderReportForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "SaleOrder",
    path: "/sale-order/edit/:id",
    element: <SaleOrderReportForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "SaleOrder",
    path: "/sale-order/draft/:id",
    element: <SaleOrderReportForm observe={false} edit={false} fromDraft={true} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "SaleOrder",
    path: "/sale-order/view/:id",
    element: <SaleOrderReportForm observe={true} edit={false} fromDraft={false} />,
  },
  // ========================================================= ***SelectWarehouseNote Form** =========================================================
  {
    packageName: "onlineShopPortal",
    entityName: "WarehouseNote",
    path: "/select-warehouse-notes/edit",
    element: <SelectWarehouseNotesForm observe={false} edit={false} fromDraft={false} />,
  },
  // ========================================================= ***SKU Form** =========================================================
  {
    packageName: "onlineShopPortal",
    entityName: "Sku",
    path: "/sku/add",
    element: <SkuForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "Sku",
    path: "/sku/edit/:id",
    element: <SkuForm observe={false} edit={false} fromDraft={false} skuUpdate={true} />,
  },
  // {
  // 	packageName: "onlineShopPortal",
  // 	entityName: "Sku",
  // 	path: "/sku/draft/:id",
  // 	element: <SkuForm observe={false} edit={false} fromDraft={true} fetchPrevDataOnLoad={true} />,
  // },
  {
    packageName: "onlineShopPortal",
    entityName: "SkuEdit",
    path: "/sku-edit/add/:id",
    element: <SkuForm observe={false} edit={false} fromDraft={false} fetchPrevDataOnLoad={true} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "SkuEdit",
    path: "/sku-edit/edit/:id",
    element: <SkuForm observe={false} edit={true} fromDraft={false} />,
  },
  // ========================================================= ***PKU Form** =========================================================
  {
    packageName: "onlineShopPortal",
    entityName: "Pku",
    path: "/pku/add",
    element: <PkuForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "Pku",
    path: "/pku/edit/:id",
    element: <PkuForm observe={false} edit={false} fromDraft={false} pkuUpdate={true} />,
  },
  // {
  // 	packageName: "onlineShopPortal",
  // 	entityName: "Pku",
  // 	path: "/pku/draft/:id",
  // 	element: <PkuForm observe={false} edit={false} fromDraft={true} fetchPrevDataOnLoad={true} />,
  // },
  {
    packageName: "onlineShopPortal",
    entityName: "PkuEdit",
    path: "/pku-edit/add/:id",
    element: <PkuForm observe={false} edit={false} fromDraft={false} fetchPrevDataOnLoad={true} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "PkuEdit",
    path: "/pku-edit/edit/:id",
    element: <PkuForm observe={false} edit={true} fromDraft={false} />,
  },
  // ========================================================= ***WarehouseGroup Form** =========================================================
  {
    packageName: "onlineShopPortal",
    entityName: "WarehouseGroup",
    path: "/warehouse-group/add",
    element: <WarehouseGroupForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "WarehouseGroup",
    path: "/warehouse-group/edit/:id",
    element: <WarehouseGroupForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "WarehouseGroup",
    path: "/warehouse-group/draft/:id",
    element: <WarehouseGroupForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***Price Form** =========================================================
  // {
  //   packageName: "onlineShopPortal",
  //   entityName: "Price",
  //   path: "/prices/add",
  //   element: <PriceForm observe={false} edit={false} fromDraft={false} />,
  // },
  // {
  //   packageName: "onlineShopPortal",
  //   entityName: "Price",
  //   path: "/prices/edit/:id",
  //   element: <PriceForm observe={false} edit={true} fromDraft={false} />,
  // },
  // {
  //   packageName: "onlineShopPortal",
  //   entityName: "Price",
  //   path: "/prices/draft/:id",
  //   element: <PriceForm observe={false} edit={false} fromDraft={true} />,
  // },
  {
    packageName: "onlineShopPortal",
    entityName: "Price",
    path: "/prices/view/:id",
    element: <PriceForm observe={true} edit={false} fromDraft={false} />,
  },
  // ========================================================= ***Discount Form** =========================================================
  {
    packageName: "onlineShopPortal",
    entityName: "Discount",
    path: "/discount/add",
    element: <DiscountForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "Discount",
    path: "/discount/edit/:id",
    element: <DiscountForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "Discount",
    path: "/discount/draft/:id",
    element: <DiscountForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***LogisticChart Form** =========================================================
  {
    packageName: "onlineShopPortal",
    entityName: "LogisticChart",
    path: "/logistic-chart/add",
    element: <LogisticChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "LogisticChart",
    path: "/logistic-chart/edit/:id",
    element: <LogisticChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "onlineShopPortal",
    entityName: "LogisticChart",
    path: "/logistic-chart/draft/:id",
    element: <LogisticChartForm observe={false} edit={false} fromDraft={true} />,
  },
];

const marketVisitForms = [
  // ========================================================= ***SupervisorMarketVisit Form** =========================================================
  {
    packageName: "posAccountControl",
    entityName: "BankAccount",
    path: "/marketVisit/SupervisorMarketVisit/add",
    element: <SupervisorMarketVisitForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "posAccountControl",
    entityName: "BankAccount",
    path: "/marketVisit/SupervisorMarketVisit/edit/:id",
    element: <SupervisorMarketVisitForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "posAccountControl",
    entityName: "BankAccount",
    path: "/marketVisit/SupervisorMarketVisit/draft/:id",
    element: <SupervisorMarketVisitForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***Admin MarketVisit Form** =========================================================
  {
    packageName: "posAccountControl",
    entityName: "BankAccount",
    path: "/marketVisit/AdminMarketVisit/add",
    element: <AdminMarketVisitForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "posAccountControl",
    entityName: "BankAccount",
    path: "/marketVisit/AdminMarketVisit/edit/:id",
    element: <AdminMarketVisitForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "posAccountControl",
    entityName: "BankAccount",
    path: "/marketVisit/AdminMarketVisit/draft/:id",
    element: <AdminMarketVisitForm observe={false} edit={false} fromDraft={true} />,
  },
];
const binfForms = [
  // ========================================================= ***BusinessUnit** =========================================================
  {
    packageName: "binf",
    entityName: "BusinessUnit",
    path: "/binf/business-unit/add",
    element: <BusinessUnitForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "binf",
    entityName: "BusinessUnit",
    path: "/binf/business-unit/edit/:id",
    element: <BusinessUnitForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "binf",
    entityName: "BusinessUnit",
    path: "/binf/business-unit/draft/:id",
    element: <BusinessUnitForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***BusinessUnit** =========================================================
  {
    packageName: "binf",
    entityName: "BuAndOfficeAdminChart",
    path: "/bu-and-office-admin-chart/add",
    element: <BuAndOfficeAdminChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "binf",
    entityName: "BuAndOfficeAdminChart",
    path: "/bu-and-office-admin-chart/edit/:id",
    element: <BuAndOfficeAdminChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "binf",
    entityName: "BuAndOfficeAdminChart",
    path: "/bu-and-office-admin-chart/draft/:id",
    element: <BuAndOfficeAdminChartForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***Office** =========================================================
  {
    packageName: "binf",
    entityName: "Office",
    path: "/binf/office/add",
    element: <OfficeForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "binf",
    entityName: "Office",
    path: "/binf/office/edit/:id",
    element: <OfficeForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "binf",
    entityName: "Office",
    path: "/binf/office/draft/:id",
    element: <OfficeForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***Person** =========================================================
  {
    packageName: "binf",
    entityName: "Person",
    path: "/binf/person/add",
    element: <PersonForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "binf",
    entityName: "Person",
    path: "/binf/person/edit/:id",
    element: <PersonForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "binf",
    entityName: "Person",
    path: "/binf/person/draft/:id",
    element: <PersonForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***  ORGANIZATIONAL TITLE** =========================================================
  {
    packageName: "binf",
    entityName: "OrganizationalTitle",
    path: "/organizational-title/add",
    element: <NewOrganizationalTitleForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "binf",
    entityName: "OrganizationalTitle",
    path: "/organizational-title/edit/:id",
    element: <NewOrganizationalTitleForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "binf",
    entityName: "OrganizationalTitle",
    path: "/organizational-title/draft/:id",
    element: <NewOrganizationalTitleForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***  ORGANIZATIONAL TITLE GROUP** =========================================================
  {
    packageName: "binf",
    entityName: "OrganizationalTitleGroup",
    path: "/organizational-title-group/add",
    element: <OrganizationalTitleGroupForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "binf",
    entityName: "OrganizationalTitleGroup",
    path: "/organizational-title-group/edit/:id",
    element: <OrganizationalTitleGroupForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "binf",
    entityName: "OrganizationalTitleGroup",
    path: "/organizational-title-group/draft/:id",
    element: <OrganizationalTitleGroupForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***  ORGANIZATIONAL LEVEL** =========================================================
  {
    packageName: "binf",
    entityName: "OrganizationalLevel",
    path: "/organizational-level/add",
    element: <OrganizationalLevelForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "binf",
    entityName: "OrganizationalLevel",
    path: "/organizational-level/edit/:id",
    element: <OrganizationalLevelForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "binf",
    entityName: "OrganizationalLevel",
    path: "/organizational-level/draft/:id",
    element: <OrganizationalLevelForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= *** CORE ENTITY** =========================================================
  {
    packageName: "binf",
    entityName: "Entity",
    path: "/entity/add",
    element: <EntityForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "binf",
    entityName: "Entity",
    path: "/entity/edit/:id",
    element: <EntityForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "binf",
    entityName: "Entity",
    path: "/entity/draft/:id",
    element: <EntityForm observe={false} edit={false} fromDraft={true} />,
  },
  // // ========================================================= ***OfficeType** =========================================================
  // {
  //   packageName: "binf",
  //   entityName: "OfficeType",
  //   path: "/office-type/add",
  //   element: <AEOOfficeType observe={false} edit={false} fromDraft={false} />,
  // },
  // {
  //   packageName: "binf",
  //   entityName: "OfficeType",
  //   path: "/office-type/edit/:id",
  //   element: <AEOOfficeType observe={false} edit={true} fromDraft={false} />,
  // },
  // {
  //   packageName: "binf",
  //   entityName: "OfficeType",
  //   path: "/office-type/draft/:id",
  //   element: <AEOOfficeType observe={false} edit={false} fromDraft={true} />,
  // },
  // // ========================================================= ***AddressType** =========================================================
  // {
  //   packageName: "binf",
  //   entityName: "AddressType",
  //   path: "/address-type/add",
  //   element: <AEOAddressType observe={false} edit={false} fromDraft={false} />,
  // },
  // {
  //   packageName: "binf",
  //   entityName: "AddressType",
  //   path: "/address-type/edit/:id",
  //   element: <AEOAddressType observe={false} edit={true} fromDraft={false} />,
  // },
  // {
  //   packageName: "binf",
  //   entityName: "AddressType",
  //   path: "/address-type/draft/:id",
  //   element: <AEOAddressType observe={false} edit={false} fromDraft={true} />,
  // }, // ========================================================= ***Contact Info Type** =========================================================
  // {
  //   packageName: "binf",
  //   entityName: "ContactInfoType",
  //   path: "/contact-info-type/add",
  //   element: <AEOContactInfoType observe={false} edit={false} fromDraft={false} />,
  // },
  // {
  //   packageName: "binf",
  //   entityName: "ContactInfoType",
  //   path: "/contact-info-type/edit/:id",
  //   element: <AEOContactInfoType observe={false} edit={true} fromDraft={false} />,
  // },
  // {
  //   packageName: "binf",
  //   entityName: "ContactInfoType",
  //   path: "/contact-info-type/draft/:id",
  //   element: <AEOContactInfoType observe={false} edit={false} fromDraft={true} />,
  // },
  // // ========================================================= ***Organization** =========================================================
  // {
  //   packageName: "binf",
  //   entityName: "Organization",
  //   path: "/organization/add",
  //   element: <AEOOrganization observe={false} edit={false} fromDraft={false} />,
  // },
  // {
  //   packageName: "binf",
  //   entityName: "Organization",
  //   path: "/organization/edit/:id",
  //   element: <AEOOrganization observe={false} edit={true} fromDraft={false} />,
  // },
  // {
  //   packageName: "binf",
  //   entityName: "Organization",
  //   path: "/organization/draft/:id",
  //   element: <AEOOrganization observe={false} edit={false} fromDraft={true} />,
  // },
];
const hrinfForms = [
  // {
  //   type: "add",
  //   path: "/job-apply/edit/:id",
  //   element: <PersonnelInformation observe={false} edit={false} fromDraft={false} editHr={true} />,
  // },

  {
    packageName: "hrinf",
    entityName: "JobApply",
    path: "/job-apply/edit/:id",
    element: <PersonnelInformation observe={false} edit={true} fromDraft={false} editHr={true} />,
  },
  {
    packageName: "hrinf",
    entityName: "JobApply",
    path: "/job-apply/add",
    element: <PersonnelInformation observe={false} edit={false} fromDraft={false} editHr={false} />,
  },
  {
    packageName: "hrinf",
    entityName: "PersonnelDocumentDigitization",
    path: "/personnel-document-digitization/edit/:id",
    element: (
      <PDDForm observe={false} edit={true} fromDraft={false} projectNameClientLoggedInFrom="ERP" />
    ),
  },
  // ========================================================= *** CORE OrganizationalTitleSalaryDifference** =========================================================
  {
    packageName: "hrinf",
    entityName: "OrganizationalTitleSalaryDifference",
    path: "/hrinf/organizational-title-salary-difference/add",
    element: <OrganizationalTitleSalaryDifferenceForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "hrinf",
    entityName: "OrganizationalTitleSalaryDifference",
    path: "/hrinf/organizational-title-salary-difference/edit/:id",
    element: <OrganizationalTitleSalaryDifferenceForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "hrinf",
    entityName: "OrganizationalTitleSalaryDifference",
    path: "/hrinf/organizational-title-salary-difference/draft/:id",
    element: <OrganizationalTitleSalaryDifferenceForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= *** Corporate Chart** =========================================================
  {
    packageName: "hcm",
    entityName: "CorporateChart",
    path: "/corporate-chart/add",
    element: <CorporateChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "hcm",
    entityName: "CorporateChart",
    path: "/corporate-chart/edit/:id",
    element: <CorporateChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "hcm",
    entityName: "CorporateChart",
    path: "/corporate-chart/draft/:id",
    element: <CorporateChartForm observe={false} edit={false} fromDraft={true} />,
  },
  //========================================================= *** OrganizationalTitle Specification** =========================================================
  {
    packageName: "hcm",
    entityName: "OrganizationalTitleSpecification",
    path: "/organizational-title-specification/add",
    element: <OrganizationalTitleSpecificationForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "hcm",
    entityName: "OrganizationalTitleSpecification",
    path: "/organizational-title-specification/edit/:id",
    element: <OrganizationalTitleSpecificationForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "hcm",
    entityName: "OrganizationalTitleSpecification",
    path: "/organizational-title-specification/draft/:id",
    element: <OrganizationalTitleSpecificationForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= *** Corporate Chart** =========================================================
  {
    packageName: "hcm",
    entityName: "HrAdminChart",
    path: "/hr-admin-chart/add",
    element: <HrAdminChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "hcm",
    entityName: "HrAdminChart",
    path: "/hr-admin-chart/edit/:id",
    element: <HrAdminChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "hcm",
    entityName: "HrAdminChart",
    path: "/hr-admin-chart/draft/:id",
    element: <HrAdminChartForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= *** Corporate Chart** =========================================================
  {
    packageName: "hcm",
    entityName: "AdministrativeAffairsChart",
    path: "/administrative-affairs-chart/add",
    element: <AdministrativeAffairsChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "hcm",
    entityName: "AdministrativeAffairsChart",
    path: "/administrative-affairs-chart/edit/:id",
    element: <AdministrativeAffairsChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "hcm",
    entityName: "AdministrativeAffairsChart",
    path: "/administrative-affairs-chart/draft/:id",
    element: <AdministrativeAffairsChartForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= *** Corporate Staff** =========================================================
  {
    packageName: "hcm",
    entityName: "CorporateStaff",
    path: "/corporate-staff/add",
    element: <CorporateStaffForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "hcm",
    entityName: "CorporateStaff",
    path: "/corporate-staff/edit/:id",
    element: <CorporateStaffForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "hcm",
    entityName: "CorporateStaff",
    path: "/corporate-staff/draft/:id",
    element: <CorporateStaffForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= *** CORE NationalCodeCellphoneOfPersonnel** =========================================================
  {
    packageName: "hrinf",
    entityName: "NationalCodeCellphoneOfPersonnel",
    path: "/hrinf/national-code-of-personnel/add",
    element: <NationalCodeCellphoneOfPersonnelForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "hrinf",
    entityName: "NationalCodeCellphoneOfPersonnel",
    path: "/hrinf/national-code-of-personnel/edit/:id",
    element: <NationalCodeCellphoneOfPersonnelForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "hrinf",
    entityName: "NationalCodeCellphoneOfPersonnel",
    path: "/hrinf/national-code-of-personnel/draft/:id",
    element: <NationalCodeCellphoneOfPersonnelForm observe={false} edit={false} fromDraft={true} />,
  },
];
const financialForms = [
  // ========================================================= ***PayrollChart Form** =========================================================
  {
    packageName: "financial",
    entityName: "PayrollChart",
    path: "/payroll-chart/add",
    element: <PayrollChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "financial",
    entityName: "PayrollChart",
    path: "/payroll-chart/edit/:id",
    element: <PayrollChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "financial",
    entityName: "PayrollChart",
    path: "/payroll-chart/draft/:id",
    element: <PayrollChartForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***BudgetingChart Form** =========================================================
  {
    packageName: "financial",
    entityName: "BudgetingChart",
    path: "/budgetting-chart/add",
    element: <BudgetingChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "financial",
    entityName: "BudgetingChart",
    path: "/budgetting-chart/edit/:id",
    element: <BudgetingChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "financial",
    entityName: "BudgetingChart",
    path: "/budgetting-chart/draft/:id",
    element: <BudgetingChartForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***FinancialInfoChart Form** =========================================================
  {
    packageName: "financial",
    entityName: "FinancialInfoChart",
    path: "/financial-info-chart/add",
    element: <FinancialInfoChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "financial",
    entityName: "FinancialInfoChart",
    path: "/financial-info-chart/edit/:id",
    element: <FinancialInfoChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "financial",
    entityName: "FinancialInfoChart",
    path: "/financial-info-chart/draft/:id",
    element: <FinancialInfoChartForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***ProcurementChart Form** =========================================================
  {
    packageName: "financial",
    entityName: "ProcurementChart",
    path: "/procurement-chart/add",
    element: <ProcurementChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "financial",
    entityName: "ProcurementChart",
    path: "/procurement-chart/edit/:id",
    element: <ProcurementChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "financial",
    entityName: "ProcurementChart",
    path: "/procurement-chart/draft/:id",
    element: <ProcurementChartForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***AccountClass Form** =========================================================
  {
    packageName: "finf",
    entityName: "AccountClass",
    path: "/account-class/add",
    element: <AccountClassForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "finf",
    entityName: "AccountClass",
    path: "/account-class/edit/:id",
    element: <AccountClassForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "finf",
    entityName: "AccountClass",
    path: "/account-class/draft/:id",
    element: <AccountClassForm observe={false} edit={false} fromDraft={true} />,
  },
  {
    packageName: "finf",
    entityName: "AccountClass",
    path: "/account-class/view/:id",
    element: <AccountClassForm observe={true} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***GeneralLedgerAccount Form** =========================================================
  {
    packageName: "finf",
    entityName: "GeneralLedgerAccount",
    path: "/general-ledger-account/add",
    element: <GeneralLedgerAccountForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "finf",
    entityName: "GeneralLedgerAccount",
    path: "/general-ledger-account/edit/:id",
    element: <GeneralLedgerAccountForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "finf",
    entityName: "GeneralLedgerAccount",
    path: "/general-ledger-account/draft/:id",
    element: <GeneralLedgerAccountForm observe={false} edit={false} fromDraft={true} />,
  },
  {
    packageName: "finf",
    entityName: "GeneralLedgerAccount",
    path: "/general-ledger-account/view/:id",
    element: <GeneralLedgerAccountForm observe={true} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***SubsidiaryAccount Form** =========================================================
  {
    packageName: "finf",
    entityName: "SubsidiaryAccount",
    path: "/subsidiary-account/add",
    element: <SubsidiaryAccountForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "finf",
    entityName: "SubsidiaryAccount",
    path: "/subsidiary-account/edit/:id",
    element: <SubsidiaryAccountForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "finf",
    entityName: "SubsidiaryAccount",
    path: "/subsidiary-account/draft/:id",
    element: <SubsidiaryAccountForm observe={false} edit={false} fromDraft={true} />,
  },
  {
    packageName: "finf",
    entityName: "SubsidiaryAccount",
    path: "/subsidiary-account/view/:id",
    element: <SubsidiaryAccountForm observe={true} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***PurchaseProforma Form** =========================================================
  {
    packageName: "financial",
    entityName: "PurchaseProforma",
    path: "/purchase-proforma/add",
    element: <PurchaseProformaForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "financial",
    entityName: "PurchaseProforma",
    path: "/purchase-proforma/edit/:id",
    element: <PurchaseProformaForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "financial",
    entityName: "PurchaseProforma",
    path: "/purchase-proforma/draft/:id",
    element: <PurchaseProformaForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***PurchaseReturnProformaWithoutUid Form** =========================================================
  {
    packageName: "financial",
    entityName: "PurchaseReturnProformaWithoutUid",
    path: "/purchase-return-proforma-without-uid/add",
    element: <PurchaseReturnProformaWithoutUidForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "financial",
    entityName: "PurchaseReturnProformaWithoutUid",
    path: "/purchase-return-proforma-without-uid/edit/:id",
    element: <PurchaseReturnProformaWithoutUidForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "financial",
    entityName: "PurchaseReturnProformaWithoutUid",
    path: "/purchase-return-proforma-without-uid/draft/:id",
    element: <PurchaseReturnProformaWithoutUidForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***PurchaseInvoice Form** =========================================================
  {
    packageName: "financial",
    entityName: "PurchaseInvoice",
    path: "/purchase-invoice/view/:id",
    element: <PurchaseInvoiceForm observe={true} edit={false} fromDraft={false} />,
  },
  // ========================================================= ***AccountingDocument Form** =========================================================
  {
    packageName: "financial",
    entityName: "AccountingDocument",
    path: "/accounting-document/add",
    element: <AccountingDocumentForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "financial",
    entityName: "AccountingDocument",
    path: "/accounting-document/edit/:id",
    element: <AccountingDocumentForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "financial",
    entityName: "AccountingDocument",
    path: "/accounting-document/draft/:id",
    element: <AccountingDocumentForm observe={false} edit={false} fromDraft={true} />,
  },
  {
    packageName: "financial",
    entityName: "AccountingDocument",
    path: "/accounting-document/view/:id",
    element: <AccountingDocumentForm observe={true} edit={false} fromDraft={true} />,
  },
];
const executiveForms = [
  // ========================================================= ***LegalChart Form** =========================================================
  {
    packageName: "executive",
    entityName: "LegalChart",
    path: "/legal-chart/add",
    element: <LegalChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "executive",
    entityName: "LegalChart",
    path: "/legal-chart/edit/:id",
    element: <LegalChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "executive",
    entityName: "LegalChart",
    path: "/legal-chart/draft/:id",
    element: <LegalChartForm observe={false} edit={false} fromDraft={true} />,
  },
  {
    packageName: "executive",
    entityName: "SecurityChart",
    path: "/security-chart/add",
    element: <SecurityChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "executive",
    entityName: "SecurityChart",
    path: "/security-chart/edit/:id",
    element: <SecurityChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "executive",
    entityName: "SecurityChart",
    path: "/security-chart/draft/:id",
    element: <SecurityChartForm observe={false} edit={false} fromDraft={true} />,
  },
];
const saleRepresentativesForms = [
  // ========================================================= ***BeautyAdvisorReport Form** =========================================================
  // {
  //   packageName: "saleRepresentatives",
  //   entityName: "BeautyAdvisorReport",
  //   path: "/beauty-advisor-report/add",
  //   element: <BeautyAdvisorReport observe={false} edit={false} fromDraft={false} />,
  // },
  // {
  //   packageName: "saleRepresentatives",
  //   entityName: "BeautyAdvisorReport",
  //   path: "/beauty-advisor-report/edit/:id",
  //   element: <BeautyAdvisorReport observe={false} edit={true} fromDraft={false} />,
  // },
  // {
  //   packageName: "saleRepresentatives",
  //   entityName: "BeautyAdvisorReport",
  //   path: "/beauty-advisor-report/draft/:id",
  //   element: <BeautyAdvisorReport observe={false} edit={false} fromDraft={true} />,
  // },
  // ========================================================= ***UserInformation Form ** =========================================================
  {
    packageName: "saleRepresentatives",
    entityName: "UserInformationContainer",
    path: "/user-information-container/add",
    element: <UserInformationForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "UserInformationContainer",
    path: "/user-information-container/edit/:id",
    element: <UserInformationForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "UserInformationContainer",
    path: "/user-information-container/draft/:id",
    element: <UserInformationForm observe={false} edit={false} fromDraft={true} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "UserInformationEdit",
    path: "/user-information-edit/add/:id",
    element: <UserInformationForm observe={false} edit={false} fromDraft={false} edition={true} />,
  },
  // ========================================================= ***SaleRepresentative Form** =========================================================
  {
    packageName: "saleRepresentatives",
    entityName: "SaleRepresentative",
    path: "/sale-representative/add",
    element: <SaleRepresentativeForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "SaleRepresentative",
    path: "/sale-representative/edit/:id",
    element: <SaleRepresentativeForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "SaleRepresentative",
    path: "/sale-representative/draft/:id",
    element: <SaleRepresentativeForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***PointOfSale Form** =========================================================
  {
    packageName: "saleRepresentatives",
    entityName: "PointOfSale",
    path: "/point-of-sale/add",
    element: <PointOfSaleForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "PointOfSale",
    path: "/point-of-sale/edit/:id",
    element: <PointOfSaleForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "PointOfSale",
    path: "/point-of-sale/draft/:id",
    element: <PointOfSaleForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***BeautyAdvisorChart Form** =========================================================
  {
    packageName: "saleRepresentatives",
    entityName: "BeautyAdvisorChart",
    path: "/beauty-advisor-chart/add",
    element: <BeautyAdvisorChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "BeautyAdvisorChart",
    path: "/beauty-advisor-chart/edit/:id",
    element: <BeautyAdvisorChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "BeautyAdvisorChart",
    path: "/beauty-advisor-chart/draft/:id",
    element: <BeautyAdvisorChartForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***SrmSoftwareSupportChart Form** =========================================================
  {
    packageName: "saleRepresentatives",
    entityName: "SrmSoftwareSupportChart",
    path: "/srm-software-support-chart/add",
    element: <SrmSoftwareSupportChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "SrmSoftwareSupportChart",
    path: "/srm-software-support-chart/edit/:id",
    element: <SrmSoftwareSupportChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "SrmSoftwareSupportChart",
    path: "/srm-software-support-chart/draft/:id",
    element: <SrmSoftwareSupportChartForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***SrmHrChart Form** =========================================================
  {
    packageName: "saleRepresentatives",
    entityName: "SrmHrChart",
    path: "/srm-hr-chart/add",
    element: <SrmHrChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "SrmHrChart",
    path: "/srm-hr-chart/edit/:id",
    element: <SrmHrChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "SrmHrChart",
    path: "/srm-hr-chart/draft/:id",
    element: <SrmHrChartForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***BeautyAdvisorSupervisionChart Form** =========================================================
  {
    packageName: "saleRepresentatives",
    entityName: "BeautyAdvisorSupervisionChart",
    path: "/beauty-advisor-supervision-chart/add",
    element: <BeautyAdvisorSupervisionChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "BeautyAdvisorSupervisionChart",
    path: "/beauty-advisor-supervision-chart/edit/:id",
    element: <BeautyAdvisorSupervisionChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "BeautyAdvisorSupervisionChart",
    path: "/beauty-advisor-supervision-chart/draft/:id",
    element: <BeautyAdvisorSupervisionChartForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***SaleSupportGeoDivisionSector Form** =========================================================
  {
    packageName: "saleRepresentatives",
    entityName: "SaleSupportGeoDivisionSector",
    path: "/sale-support-geo-division-sector/add",
    element: <SaleSupportGeoDivisionSectorForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "SaleSupportGeoDivisionSector",
    path: "/sale-support-geo-division-sector/edit/:id",
    element: <SaleSupportGeoDivisionSectorForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "SaleSupportGeoDivisionSector",
    path: "/sale-support-geo-division-sector/draft/:id",
    element: <SaleSupportGeoDivisionSectorForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***BeautyAdvisorSupervisionSector Form** =========================================================
  {
    packageName: "saleRepresentatives",
    entityName: "BeautyAdvisorSupervisionSector",
    path: "/beauty-advisor-supervision-sector/add",
    element: <BeautyAdvisorSupervisionSectorForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "BeautyAdvisorSupervisionSector",
    path: "/beauty-advisor-supervision-sector/edit/:id",
    element: <BeautyAdvisorSupervisionSectorForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "BeautyAdvisorSupervisionSector",
    path: "/beauty-advisor-supervision-sector/draft/:id",
    element: <BeautyAdvisorSupervisionSectorForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***BeautyAdvisorSupervisorReport Form** =========================================================
  {
    packageName: "saleRepresentatives",
    entityName: "BeautyAdvisorSupervisorReport",
    path: "/beauty-advisor-supervisor-report/add",
    element: <BeautyAdvisorSupervisorReportForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "BeautyAdvisorSupervisorReport",
    path: "/beauty-advisor-supervisor-report/edit/:id",
    element: <BeautyAdvisorSupervisorReportForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "BeautyAdvisorSupervisorReport",
    path: "/beauty-advisor-supervisor-report/draft/:id",
    element: <BeautyAdvisorSupervisorReportForm observe={false} edit={false} fromDraft={true} />,
  },
];
const medrepForms = [
  // ========================================================= ***MedicalAffairsChart Form** =========================================================
  {
    packageName: "saleRepresentatives",
    entityName: "MedicalAffairsChart",
    path: "/medical-affairs-chart/add",
    element: <MedicalAffairsChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "MedicalAffairsChart",
    path: "/medical-affairs-chart/edit/:id",
    element: <MedicalAffairsChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "MedicalAffairsChart",
    path: "/medical-affairs-chart/draft/:id",
    element: <MedicalAffairsChartForm observe={false} edit={false} fromDraft={true} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "MedicalAffairsChart",
    path: "/medical-affairs-chart/view/:id",
    element: <MedicalAffairsChartForm observe={true} edit={false} fromDraft={false} />,
  },
  // ========================================================= ***MedRepChart Form** =========================================================
  {
    packageName: "saleRepresentatives",
    entityName: "MedRepChart",
    path: "/med-rep-chart/add",
    element: <MedRepChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "MedRepChart",
    path: "/med-rep-chart/edit/:id",
    element: <MedRepChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "MedRepChart",
    path: "/med-rep-chart/draft/:id",
    element: <MedRepChartForm observe={false} edit={false} fromDraft={true} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "MedRepChart",
    path: "/med-rep-chart/view/:id",
    element: <MedRepChartForm observe={true} edit={false} fromDraft={false} />,
  },
  // ========================================================= ***MedRepChart Form** =========================================================
  {
    packageName: "saleRepresentatives",
    entityName: "MedRepChart",
    path: "/med-rep-geo-division-sector/add",
    element: <MedRepGeoDivisionSectorForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "MedRepChart",
    path: "/med-rep-geo-division-sector/edit/:id",
    element: <MedRepGeoDivisionSectorForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "MedRepChart",
    path: "/med-rep-geo-division-sector/draft/:id",
    element: <MedRepGeoDivisionSectorForm observe={false} edit={false} fromDraft={true} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "MedRepChart",
    path: "/med-rep-geo-division-sector/view/:id",
    element: <MedRepGeoDivisionSectorForm observe={true} edit={false} fromDraft={false} />,
  },
  // ========================================================= ***SrmStockManagementChart Form** =========================================================
  {
    packageName: "saleRepresentatives",
    entityName: "SrmStockManagementChart",
    path: "/srm-stock-management-chart/add",
    element: <SrmStockManagementChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "SrmStockManagementChart",
    path: "/srm-stock-management-chart/edit/:id",
    element: <SrmStockManagementChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "SrmStockManagementChart",
    path: "/srm-stock-management-chart/draft/:id",
    element: <SrmStockManagementChartForm observe={false} edit={false} fromDraft={true} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "SrmStockManagementChart",
    path: "/srm-stock-management-chart/view/:id",
    element: <SrmStockManagementChartForm observe={true} edit={false} fromDraft={false} />,
  },
  // ========================================================= ***StockableObjectManagementChart Form** =========================================================
  {
    packageName: "saleRepresentatives",
    entityName: "StockableObjectManagementChart",
    path: "/stockable-object-management-chart/add",
    element: <StockableObjectManagementChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "StockableObjectManagementChart",
    path: "/stockable-object-management-chart/edit/:id",
    element: <StockableObjectManagementChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "StockableObjectManagementChart",
    path: "/stockable-object-management-chart/draft/:id",
    element: <StockableObjectManagementChartForm observe={false} edit={false} fromDraft={true} />,
  },
  {
    packageName: "saleRepresentatives",
    entityName: "StockableObjectManagementChart",
    path: "/stockable-object-management-chart/view/:id",
    element: <StockableObjectManagementChartForm observe={true} edit={false} fromDraft={false} />,
  },
];
const mlmForms = [
  // ========================================================= ***LegalChart Form** =========================================================
  {
    packageName: "mlm",
    entityName: "NrmChart",
    path: "/nrm-chart/add",
    element: <NRMChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "mlm",
    entityName: "NrmChart",
    path: "/nrm-chart/edit/:id",
    element: <NRMChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "mlm",
    entityName: "NrmChart",
    path: "/nrm-chart/draft/:id",
    element: <NRMChartForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***LegalChart Form** =========================================================
  {
    packageName: "mlm",
    entityName: "DeliveryTariff",
    path: "/delivery-tariff/add",
    element: <DeliveryTariffForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "mlm",
    entityName: "DeliveryTariff",
    path: "/delivery-tariff/edit/:id",
    element: <DeliveryTariffForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "mlm",
    entityName: "DeliveryTariff",
    path: "/delivery-tariff/draft/:id",
    element: <DeliveryTariffForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***LegalChart Form** =========================================================
  {
    packageName: "mlm",
    entityName: "FreightBox",
    path: "/freight-box/add",
    element: <FreightBoxForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "mlm",
    entityName: "FreightBox",
    path: "/freight-box/edit/:id",
    element: <FreightBoxForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "mlm",
    entityName: "FreightBox",
    path: "/freight-box/draft/:id",
    element: <FreightBoxForm observe={false} edit={false} fromDraft={true} />,
  },

  // ========================================================= ***LegalChart Form** =========================================================
  {
    packageName: "mlm",
    entityName: "DefectiveProductStatement",
    path: "/defective-product-statement/add",
    element: <DefectiveProductStatementForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "mlm",
    entityName: "DefectiveProductStatement",
    path: "/defective-product-statement/edit/:id",
    element: <DefectiveProductStatementForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "mlm",
    entityName: "DefectiveProductStatement",
    path: "/defective-product-statement/draft/:id",
    element: <DefectiveProductStatementForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***LegalChart Form** =========================================================
  {
    packageName: "mlm",
    entityName: "InspectionRequestOfDefectiveProductReturn",
    path: "/inspection-request-of-defective-product-return/add",
    element: (
      <InspectionRequestOfDefectiveProductReturnForm observe={false} edit={false} fromDraft={false} />
    ),
  },
  {
    packageName: "mlm",
    entityName: "InspectionRequestOfDefectiveProductReturn",
    path: "/inspection-request-of-defective-product-return/edit/:id",
    element: (
      <InspectionRequestOfDefectiveProductReturnForm observe={false} edit={true} fromDraft={false} />
    ),
  },
  {
    packageName: "mlm",
    entityName: "InspectionRequestOfDefectiveProductReturn",
    path: "/inspection-request-of-defective-product-return/draft/:id",
    element: (
      <InspectionRequestOfDefectiveProductReturnForm observe={false} edit={false} fromDraft={true} />
    ),
  },
  // ========================================================= ***CustomerReceivableResolution Form** =========================================================
  {
    packageName: "mlm",
    entityName: "CustomerReceivableResolution",
    path: "/customer-receivable-resolution/add",
    element: <CustomerReceivableResolutionForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "mlm",
    entityName: "CustomerReceivableResolution",
    path: "/customer-receivable-resolution/edit/:id",
    element: <CustomerReceivableResolutionForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "mlm",
    entityName: "CustomerReceivableResolution",
    path: "/customer-receivable-resolution/draft/:id",
    element: <CustomerReceivableResolutionForm observe={false} edit={false} fromDraft={true} />,
  },
  {
    packageName: "mlm",
    entityName: "CustomerReceivableResolution",
    path: "/customer-receivable-resolution/view/:id",
    element: <CustomerReceivableResolutionForm observe={true} edit={false} fromDraft={false} />,
  },
  // ========================================================= ***CategoryManagementChart Form** =========================================================
  {
    packageName: "mlm",
    entityName: "CategoryManagementChart",
    path: "/category_management_chart/add",
    element: <CategoryManagementChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "mlm",
    entityName: "CategoryManagementChart",
    path: "/category_management_chart/edit/:id",
    element: <CategoryManagementChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "mlm",
    entityName: "CategoryManagementChart",
    path: "/category_management_chart/draft/:id",
    element: <CategoryManagementChartForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***ContractTerminationRequest Form** =========================================================
  {
    packageName: "mlm",
    entityName: "ContractTerminationRequest",
    path: "/contract-termination-request/add",
    element: <ContractTerminationRequestForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "mlm",
    entityName: "ContractTerminationRequest",
    path: "/contract-termination-request/edit/:id",
    element: <ContractTerminationRequestForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "mlm",
    entityName: "ContractTerminationRequest",
    path: "/contract-termination-request/draft/:id",
    element: <ContractTerminationRequestForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***LegalChart Form** =========================================================
  {
    packageName: "mlm",
    entityName: "Seller",
    path: "/seller/add",
    element: <SellerFrom observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "mlm",
    entityName: "Seller",
    path: "/seller/edit/:id",
    element: <SellerFrom observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "mlm",
    entityName: "Seller",
    path: "/seller/draft/:id",
    element: <SellerFrom observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***LegalChart Form** =========================================================
  {
    packageName: "mlm",
    entityName: "NetworkMarketer",
    path: "/network-marketer/add",
    element: <IsMarketerForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "mlm",
    entityName: "NetworkMarketer",
    path: "/network-marketer/edit/:id",
    element: <IsMarketerForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "mlm",
    entityName: "NetworkMarketer",
    path: "/network-marketer/draft/:id",
    element: <IsMarketerForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***LegalChart Form** =========================================================
  {
    packageName: "mlm",
    entityName: "RoyalZhickNetworkMarketer",
    path: "/royal/add",
    element: <RoyalZhickNetworkmarketerForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "mlm",
    entityName: "RoyalZhickNetworkMarketer",
    path: "/royal/edit/:id",
    element: <RoyalZhickNetworkmarketerForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "mlm",
    entityName: "RoyalZhickNetworkMarketer",
    path: "/royal/draft/:id",
    element: <RoyalZhickNetworkmarketerForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***LegalChart Form** =========================================================
  {
    packageName: "mlm",
    entityName: "GeographicalDivision",
    path: "/geographicalDivision/add",
    element: <GeographicalDivisionForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "mlm",
    entityName: "GeographicalDivision",
    path: "/geographicalDivision/edit/:id",
    element: <GeographicalDivisionForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "mlm",
    entityName: "GeographicalDivision",
    path: "/geographicalDivision/draft/:id",
    element: <GeographicalDivisionForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***LegalChart Form** =========================================================
  {
    packageName: "mlm",
    entityName: "SaleSupportChart",
    path: "/sale-support-chart/add",
    element: <SaleSupportChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "mlm",
    entityName: "SaleSupportChart",
    path: "/sale-support-chart/edit/:id",
    element: <SaleSupportChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "mlm",
    entityName: "SaleSupportChart",
    path: "/sale-support-chart/draft/:id",
    element: <SaleSupportChartForm observe={false} edit={false} fromDraft={true} />,
  },

  // ========================================================= ***LegalChart Form** =========================================================
  {
    packageName: "mlm",
    entityName: "ProductManagementChart",
    path: "/product-managment-chart/add",
    element: <ProductManagementChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "mlm",
    entityName: "ProductManagementChart",
    path: "/product-managment-chart/edit/:id",
    element: <ProductManagementChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "mlm",
    entityName: "ProductManagementChart",
    path: "/product-managment-chart/draft/:id",
    element: <ProductManagementChartForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***LegalChart Form** =========================================================
  {
    packageName: "mlm",
    entityName: "SellerSupportChart",
    path: "/seller-support-chart/add",
    element: <SellerSupportChartForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "mlm",
    entityName: "SellerSupportChart",
    path: "/seller-support-chart/edit/:id",
    element: <SellerSupportChartForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "mlm",
    entityName: "SellerSupportChart",
    path: "/seller-support-chart/draft/:id",
    element: <SellerSupportChartForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***ComplainCaseForm Form**
  {
    packageName: "mlm",
    entityName: "ComplaintCase",
    path: "/complaint-case/edit/:id",
    element: <ComplaintCaseForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "mlm",
    entityName: "ComplaintCase",
    path: "/complaint-case/draft/:id",
    element: <ComplaintCaseForm observe={false} edit={false} fromDraft={true} />,
  },
  // ========================================================= ***SkuSeller Form** =========================================================
  {
    packageName: "mlm",
    entityName: "SkuSeller",
    path: "/sku-seller/add",
    element: <SkuSellerForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "mlm",
    entityName: "SkuSeller",
    path: "/sku-seller/edit/:id",
    element: <SkuSellerForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "mlm",
    entityName: "SkuSeller",
    path: "/sku-seller/draft/:id",
    element: <SkuSellerForm observe={false} edit={false} fromDraft={true} />,
  },
  {
    packageName: "mlm",
    entityName: "SkuSeller",
    path: "/sku-seller/view/:id",
    element: <SkuSellerForm observe={true} edit={false} fromDraft={false} />,
  },
];
const hcmRoutes = [
  // ===================================== ***JobPosition Form** ========================================
  {
    packageName: "hcm",
    entityName: "JobPosition",
    path: "/job-position/add",
    element: <JobPositionForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "hcm",
    entityName: "JobPosition",
    path: "/job-position/edit/:id",
    element: <JobPositionForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "hcm",
    entityName: "JobPosition",
    path: "/job-position/draft/:id",
    element: <JobPositionForm observe={false} edit={false} fromDraft={true} />,
  },
  {
    packageName: "hcm",
    entityName: "JobPosition",
    path: "/job-position/view/:id",
    element: <JobPositionForm observe={true} edit={false} fromDraft={false} />,
  },
  // ===================================== ***HrSegment Form** ========================================
  {
    packageName: "hcm",
    entityName: "HrSegment",
    path: "/hr-segment/add",
    element: <HrSegmentForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "hcm",
    entityName: "HrSegment",
    path: "/hr-segment/edit/:id",
    element: <HrSegmentForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "hcm",
    entityName: "HrSegment",
    path: "/hr-segment/draft/:id",
    element: <HrSegmentForm observe={false} edit={false} fromDraft={true} />,
  },
  {
    packageName: "hcm",
    entityName: "HrSegment",
    path: "/hr-segment/view/:id",
    element: <HrSegmentForm observe={true} edit={false} fromDraft={false} />,
  },
  // // ===================================== ***InterviewSchedulingAndRescheduling Form** ========================================
  {
    packageName: "hcm",
    entityName: "InterviewSchedulingAndRescheduling",
    path: "/interview-scheduling-and-rescheduling/add",
    element: <InterviewSchedulingAndReschedulingForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "hcm",
    entityName: "InterviewSchedulingAndRescheduling",
    path: "/interview-scheduling-and-rescheduling/edit/:id",
    element: <InterviewSchedulingAndReschedulingForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "hcm",
    entityName: "InterviewSchedulingAndRescheduling",
    path: "/interview-scheduling-and-rescheduling/draft/:id",
    element: <InterviewSchedulingAndReschedulingForm observe={false} edit={false} fromDraft={true} />,
  },
  {
    packageName: "hcm",
    entityName: "InterviewSchedulingAndRescheduling",
    path: "/interview-scheduling-and-rescheduling/view/:id",
    element: <InterviewSchedulingAndReschedulingForm observe={true} edit={false} fromDraft={false} />,
  }, // ===================================== ***CandidateScreening Form** ========================================
  {
    packageName: "hcm",
    entityName: "CandidateScreening",
    path: "/candidate-screening/add",
    element: <CandidateScreeningForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "hcm",
    entityName: "CandidateScreening",
    path: "/candidate-screening/edit/:id",
    element: <CandidateScreeningForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "hcm",
    entityName: "CandidateScreening",
    path: "/candidate-screening/draft/:id",
    element: <CandidateScreeningForm observe={false} edit={false} fromDraft={true} />,
  },
  {
    packageName: "hcm",
    entityName: "CandidateScreening",
    path: "/candidate-screening/view/:id",
    element: <CandidateScreeningForm observe={true} edit={false} fromDraft={false} />,
  }, // ===================================== ***CandidateAssessment Form** ========================================
  {
    packageName: "hcm",
    entityName: "CandidateAssessment",
    path: "/candidate-assessment/add",
    element: <CandidateAssessmentForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "hcm",
    entityName: "CandidateAssessment",
    path: "/candidate-assessment/edit/:id",
    element: <CandidateAssessmentForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "hcm",
    entityName: "CandidateAssessment",
    path: "/candidate-assessment/draft/:id",
    element: <CandidateAssessmentForm observe={false} edit={false} fromDraft={true} />,
  },
  {
    packageName: "hcm",
    entityName: "CandidateAssessment",
    path: "/candidate-assessment/view/:id",
    element: <CandidateAssessmentForm observe={true} edit={false} fromDraft={false} />,
  },
];
const gsmRoutes = [
  // ===================================== ***GsmRouting Form** ========================================
  {
    packageName: "gsm",
    entityName: "GsmRouting",
    path: "/gsm-routing/add",
    element: <GsmRoutingForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "gsm",
    entityName: "GsmRouting",
    path: "/gsm-routing/edit/:id",
    element: <GsmRoutingForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "gsm",
    entityName: "GsmRouting",
    path: "/gsm-routing/draft/:id",
    element: <GsmRoutingForm observe={false} edit={false} fromDraft={true} />,
  },
  {
    packageName: "gsm",
    entityName: "GsmRouting",
    path: "/gsm-routing/view/:id",
    element: <GsmRoutingForm observe={true} edit={false} fromDraft={false} />,
  },
  // ===================================== ***CognitiveTestQuestion Form** ========================================
  {
    packageName: "hcm",
    entityName: "CognitiveTestQuestion",
    path: "/cognitive-test-question/add",
    element: <CognitiveTestQuestionForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "hcm",
    entityName: "CognitiveTestQuestion",
    path: "/cognitive-test-question/edit/:id",
    element: <CognitiveTestQuestionForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "hcm",
    entityName: "CognitiveTestQuestion",
    path: "/cognitive-test-question/draft/:id",
    element: <CognitiveTestQuestionForm observe={false} edit={false} fromDraft={true} />,
  },
  {
    packageName: "hcm",
    entityName: "CognitiveTestQuestion",
    path: "/cognitive-test-question/view/:id",
    element: <CognitiveTestQuestionForm observe={true} edit={false} fromDraft={false} />,
  },
  // ===================================== ***CandidateSelection Form** ========================================
  // {
  //   packageName: "hcm",
  //   entityName: "CandidateSelection",
  //   path: "/candidate-selection/add",
  //   element: <CandidateSelectionForm observe={false} edit={false} fromDraft={false} />,
  // },
  {
    packageName: "hcm",
    entityName: "CandidateSelection",
    path: "/candidate-selection/edit/:id",
    element: <CandidateSelectionForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "hcm",
    entityName: "CandidateSelection",
    path: "/candidate-selection/draft/:id",
    element: <CandidateSelectionForm observe={false} edit={false} fromDraft={true} />,
  },
  {
    packageName: "hcm",
    entityName: "CandidateSelection",
    path: "/candidate-selection/view/:id",
    element: <CandidateSelectionForm observe={true} edit={false} fromDraft={false} />,
  },
  // ===================================== ***Hiring Form** ========================================
  {
    packageName: "hcm",
    entityName: "Hiring",
    path: "/hiring/add",
    element: <HiringForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "hcm",
    entityName: "Hiring",
    path: "/hiring/edit/:id",
    element: <HiringForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "hcm",
    entityName: "Hiring",
    path: "/hiring/draft/:id",
    element: <HiringForm observe={false} edit={false} fromDraft={true} />,
  },
  {
    packageName: "hcm",
    entityName: "Hiring",
    path: "/hiring/view/:id",
    element: <HiringForm observe={true} edit={false} fromDraft={false} />,
  },
  // ===================================== ***DocumentSubmissionScheduling Form** ========================================
  {
    packageName: "hcm",
    entityName: "DocumentSubmissionScheduling",
    path: "/document-submission-scheduling/add",
    element: <DocumentSubmissionSchedulingForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "hcm",
    entityName: "DocumentSubmissionScheduling",
    path: "/document-submission-scheduling/edit/:id",
    element: <DocumentSubmissionSchedulingForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "hcm",
    entityName: "DocumentSubmissionScheduling",
    path: "/document-submission-scheduling/draft/:id",
    element: <DocumentSubmissionSchedulingForm observe={false} edit={false} fromDraft={true} />,
  },
  {
    packageName: "hcm",
    entityName: "DocumentSubmissionScheduling",
    path: "/document-submission-scheduling/view/:id",
    element: <DocumentSubmissionSchedulingForm observe={true} edit={false} fromDraft={false} />,
  },
  // ===================================== ***JobPosition Report** ========================================
  {
    packageName: "hcm",
    entityName: "InterviewSchedulingAndRescheduling",
    path: "/job-position-report/view/:id",
    element: <JobPositionReport observe={false} edit={false} fromDraft={false} />,
  },
];

const delegationRoutes = [
  {
    packageName: "delegation",
    entityName: "DefineDelegation",
    path: "/define-delegation/add",
    element: <DelegationForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    packageName: "delegation",
    entityName: "DefineDelegation",
    path: "/define-delegation/edit/:id",
    element: <DelegationForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "delegation",
    entityName: "DefineDelegation",
    path: "/define-delegation/draft/:id",
    element: <DelegationForm observe={false} edit={false} fromDraft={true} />,
  },
  {
    packageName: "delegation",
    entityName: "DefineDelegation",
    path: "/define-delegation/view/:id",
    element: <DelegationForm observe={true} edit={false} fromDraft={false} />,
  },
];

const correspondenceRoutes = [
  {
    packageName: "correspondence",
    entityName: "CorrespondenceReceiverRouting",
    path: "/correspondence/add",
    element: (
      <CorrespondenceInboxForm isInsertForm={true} observe={false} edit={false} fromDraft={false} />
    ),
  },
  {
    packageName: "correspondence",
    entityName: "CorrespondenceReceiverRouting",
    path: "/correspondence/edit/:id",
    element: <CorrespondenceInboxForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    packageName: "correspondence",
    entityName: "CorrespondenceReceiverRouting",
    path: "/correspondence/draft/:id",
    element: <CorrespondenceInboxForm observe={false} edit={false} fromDraft={true} />,
  },
  {
    packageName: "correspondence",
    entityName: "CorrespondenceReceiverRouting",
    path: "/correspondence/view/:id",
    element: <CorrespondenceInboxForm observe={true} edit={false} fromDraft={false} />,
  },
  // {
  //   packageName: "correspondence",
  //   entityName: "Sent",
  //   path: "/sent/add",
  //   element: <CorrespondenceSentForm observe={false} edit={false} fromDraft={false} />,
  // },
  // {
  //   packageName: "correspondence",
  //   entityName: "Sent",
  //   path: "/sent/edit/:id",
  //   element: <CorrespondenceSentForm observe={false} edit={true} fromDraft={false} />,
  // },
  // {
  //   packageName: "correspondence",
  //   entityName: "Sent",
  //   path: "/sent/draft/:id",
  //   element: <CorrespondenceSentForm observe={false} edit={false} fromDraft={true} />,
  // },
  // {
  //   packageName: "correspondence",
  //   entityName: "Sent",
  //   path: "/sent/view/:id",
  //   element: <CorrespondenceDraftForm observe={true} edit={false} fromDraft={false} />,
  // },  {
  //   packageName: "correspondence",
  //   entityName: "Draft",
  //   path: "/draft/add",
  //   element: <CorrespondenceDraftForm observe={false} edit={false} fromDraft={false} />,
  // },
  // {
  //   packageName: "correspondence",
  //   entityName: "Draft",
  //   path: "/draft/edit/:id",
  //   element: <CorrespondenceDraftForm observe={false} edit={true} fromDraft={false} />,
  // },
  // {
  //   packageName: "correspondence",
  //   entityName: "Draft",
  //   path: "/draft/draft/:id",
  //   element: <CorrespondenceDraftForm observe={false} edit={false} fromDraft={true} />,
  // },
  // {
  //   packageName: "correspondence",
  //   entityName: "Draft",
  //   path: "/draft/view/:id",
  //   element: <CorrespondenceDraftForm observe={true} edit={false} fromDraft={false} />,
  // },
];

const adminPanelRoutes = [
  ...ospChartStaffForms,
  ...pacChartStaffForms,
  ...generalChartStaffForms,
  ...ospAdminForms,
  ...generalForms,
  ...coreAccessForms,
  ...pacForms,
  ...pavForms,
  ...dbacDmacGeneralForms,
  ...marketVisitForms,
  ...binfForms,
  ...hrinfForms,
  ...financialForms,
  ...executiveForms,
  ...mlmForms,
  ...saleRepresentativesForms,
  ...medrepForms,
  ...hcmRoutes,
  ...correspondenceRoutes,
  ...gsmRoutes,
  ...delegationRoutes,
];

export default adminPanelRoutes;
